/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./js/lib/andy.data.js":
/*!*****************************!*\
  !*** ./js/lib/andy.data.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
    get: function (key) {
        if (localStorage[key]) {
            return JSON.parse(localStorage[key]);
        } else return undefined;
    },
    search: function (query) {
        let result = [];
        let keys = Object.keys(localStorage);
        for (let i = 0; i < keys.length; i++) {
            if (keys[i].includes(query)) {
                result.push(JSON.parse(localStorage[keys[i]]));
            }
        }
        return result;
    },
    put: function (key, value) {
        localStorage[key] = JSON.stringify(value);
    },
    remove: function (key) {
        localStorage.removeItem(key);
    }
}


/***/ }),

/***/ "./js/lib/andy.dataset.js":
/*!********************************!*\
  !*** ./js/lib/andy.dataset.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

let _datasets = {};

module.exports = function (channel, options = {}) {

    if (_datasets[channel]) {
        return _datasets[channel];
    }

    let dataset = {};
    let sendQueue = [];

    let token = null;

    if (andy) {
        if (andy.Auth) {
            if (andy.Auth.token) {
                token = andy.Auth.token;
            }
        }
    }

    let defaultOptions = {
        socket: (typeof socket != 'undefined') ? socket : null,
        key: '_id',
        autoFetch: true,
        token,
        persist: false
    }

    options = { ...defaultOptions, ...options };

    let events = {
        error: [],
        add: [],
        save: [],
        update: [],
        remove: [],
        fetch: []
    }

    if (!options.socket) {
        // console.log(options);
        console.error('Andy dataset: no socket to connect!');
        return;
    }

    function set(data, key) {
        if(!data) return;

        for (let key in dataset) {
            delete dataset[key];
        }
        
        data.forEach(function (document) {
            dataset[document[key]] = document;
        });
        dispatchEvent('fetch', { dataset });
    }


    function save(document, cb) {
        let sendObject = { action: 'save', value: document, token: options.token };
        if (options.socket.connected) {
            //if connected send changes now
            options.socket.emit(channel, sendObject, function ({ success, value, error, isNew = undefined }) {
                if (success) {
                    updateLocalDataset(value, options.key, isNew);
                } else {
                    // handle error
                    console.log('error save', error);
                }
                if (cb) {
                    cb(...arguments);
                }
            });
        } else {
            // put on queue and send when connected
            sendQueue.push({ sendObject, createdTime: Date.now() });
        }
    }

    function removeFromLocalDataset(document, key) {
        if (dataset[document[key]]) {
            delete dataset[document[key]];
        }
        dispatchEvent('remove', { dataset, document });
    }

    function updateLocalDataset(document, key, isNew = undefined) {
        dataset[document[key]] = document;
        dispatchEvent('save', { dataset, document, isNew });
    }

    function on(event, cb) {
        if (events[event]) {
            if (events[event].push) {
                events[event].push(cb);
            }
        }
    }

    function fetch() {
        options.socket.emit(channel, {
            action: 'fetch',
            value: '',
            token: options.token
        }, function (res) {
            set(res.value, options.key);
            if (options.persist) {
                andy.data.put(`_dts.${channel}`, res.value);
            }
        });
    }

    function remove(document, cb) {
        options.socket.emit(channel, {
            action: 'remove',
            value: document,
            token: options.token
        }, function ({ success, value }) {
            if (success) {
                removeFromLocalDataset(value, options.key);
                if (typeof cb !== 'undefined') cb({ success: true, value });
            } else {
                // handle error
                // console.log('error remove');
            }
        });
    }

    options.socket.on(channel, function (data) {
        switch (data.action) {
            case 'remove':
                removeFromLocalDataset(data.value, options.key);
                break;
            case 'update':
                updateLocalDataset(data.value, options.key, data.isNew);
                break;
            case 'list':  // keeping list for compatibility
                if (options.persist) {
                    andy.data.put(`_dts.${channel}`, data.value);
                }
                set(data.value, options.key);
                break;
            case 'change':
                switch (data.type) {
                    case 'insert':
                        updateLocalDataset(data.value, options.key, data.isNew);
                    case 'update':
                        fetch();
                        break;
                    case 'delete':
                        removeFromLocalDataset(data.value, options.key);
                        break;
                }
                break;
        }
    });

    if (options.socket.connected) {

        if (options.autoFetch) {
            fetch();
        }

        options.socket.on('reconnect', function () {
            if (options.autoFetch) {
                fetch();
            }
            if (Object.keys(sendQueue).length > 0) {
                //send values in queue
                // TODO
            }
        });

    } else {
        if (options.persist) {
            let data = andy.data.get(`_dts.${channel}`);
            if (data) {
                set(data, options.key);
            }
        }
        options.socket.on('connect', function () {
            if (options.autoFetch) {
                fetch();
            }
            if (Object.keys(sendQueue).length > 0) {
                //send values in queue
                // TODO
            }
        });
    }

    function dispatchEvent(event, value) {
        events[event].forEach(function (evt) {
            evt(value);
        });
    }

    let public = {
        set data(val) {
            return;
        },
        get data() {
            return dataset
        },
        save,
        remove,
        on,
        fetch,
    }

    _datasets[channel] = public;

    return public
}

/***/ }),

/***/ "./js/lib/andy.language.js":
/*!*********************************!*\
  !*** ./js/lib/andy.language.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
    dictionaries: {},
    dictionary: [],
    current: null,
    get: function (code) {
        if (typeof this.dictionary[code] !== 'undefined') {
            return this.dictionary[code];
        } else {
            return code;
        }
    },
    update: function () {
        let elements = document.querySelectorAll('[data-label]');
        for (let i = 0; i < elements.length; i++) {
            let name = elements[i].getAttribute('data-label');
            if (typeof this.dictionary[name] !== 'undefined') {
                elements[i].innerHTML = this.dictionary[name];
            } else {
                elements[i].innerHTML = name;
            }
        }
    },
    add: function (isocode, key, value) {
        if (!this.dictionaries[isocode]) {
            this.dictionaries[isocode] = {};
            this.dictionaries[isocode][key] = value;
        } else {
            this.dictionaries[isocode][key] = value;
        }
    },
    addBulk: function (isocode, values) {
        if (!this.dictionaries[isocode]) {
            this.dictionaries[isocode] = {};
        }
        let dictionary = this.dictionaries[isocode];
        Object.keys(values).forEach(function (key) {

            dictionary[key] = values[key];
        });
        this.update();
    },
    getLanguagesAvailable: function () {
        return Object.keys(this.dictionaries);
    },
    selectLanguage: function (code) {
        if (this.dictionaries[code]) {
            this.dictionary = this.dictionaries[code];
            this.current = code;
            this.update();
        } else {
            console.log('Invalid code');
        }
    },
    getFromObject: function (obj) {
        if (!obj) return {};

        if (typeof obj === 'object') {
            if (obj[this.current]) {
                return obj[this.current];
            } else {
                return obj[Object.keys(obj)[0]];
            }
        } else {
            return obj;
        }
    }
}


/***/ }),

/***/ "./js/lib/andy.object.js":
/*!*******************************!*\
  !*** ./js/lib/andy.object.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

let _instances = {};

module.exports = function (options) {

    let items = {};

    let defaultOptions = {
        code: andy.uid.generate(),
        global: true
    }

    options = { ...defaultOptions, ...options };

    if (options.global && _instances[options.code]) {
        return _instances[options.code];
    }

    function createObjectItem(key) {

        let value;
        let events = new andy.EventManager();

        let item = {
            set value(val) {
                if (val != value) {
                    value = val;
                    events.dispatchEvent('change', value);
                } else {
                    events.dispatchEvent('set', value);
                }
            },
            get value() {
                events.dispatchEvent('get', value);
                return value;
            },
            on: events.addEventListener
        }

        items[key] = item;
        return item;

    }

    function set(key, value) {
        if (!items[key]) {
            createObjectItem(key);
        }
        items[key].value = value;
    }

    function get(key) {
        return items[key].value;
    }

    function listen(key, event, callback) {
        items[key].on(event, callback);
    }


    function getValueAsObject() {
        let keys = Object.keys(items);
    }



    function convertObjectToFlatKeys(object, path = '', parentIsArray = false) {
        let keys = Object.keys(object);
        keys.forEach(function (key) {
            let childPath = `${path}.${(parentIsArray) ? '[' + key + ']' : key}`;

            try {
                if (typeof object[key] == 'object') {
                    convertObjectToFlatKeys(object[key], childPath, Array.isArray(object[key]));
                } else {
                    items[childPath] = object[key];
                }
            } catch (error) {
                console.error('Cannot convert ', childPath);
            }
        })
    }

    function convertFlatKeysToObject() {
        let result = {};

        function passObj(obj, key) {
            return obj[key];
        }

        let keys = Object.keys(items);
        keys.forEach(function (key) {
            result = { ...result, ...constructObject(key, items[key]) };
        });
        return result;
    };

    function constructObject(path, value) {
        let obj = {};
        let arr = path.split('.');
        if (!arr[0].trim()) {
            arr.shift();
        }
        let key = arr.shift();
        if (arr.length > 0) {
            obj[key] = constructObject(arr.join('.'), value);
        } else {
            obj[key] = value;
        }
        return obj;
    };





    let public = {
        set,
        get,
        listen
    }

    if (options.global) {
        _instances[options.code] = public;
    }

    return public;

}

/***/ }),

/***/ "./js/lib/andy.router.js":
/*!*******************************!*\
  !*** ./js/lib/andy.router.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function () {

    let routes = {};
    let locked = true;

    function subscribe(route, cb) {
        if (!routes[route]) {
            routes[route] = [];
        }
        routes[route].push(cb);
    }

    function processRoute(route) {
        let r = route.split('/');
        let rts = [];
        rts.push(route);
        for (let i = 0; i < r.length; i++) {
            r.pop();
            rts.push(r.join('/'));
        }
        return rts.reverse();
    }

    function setRoute(route) {
        if (!locked) {
            window.history.pushState({ route: route }, route, route);
        }
    }

    function go(route) {
        let processed = processRoute(route);
        for (let i = 0; i < processed.length; i++) {
            let stop = (i === processed.length - 1) ? true : false;
            if (routes[processed[i]]) {
                routes[processed[i]].forEach(function (cb) {
                    cb(stop, route);
                });
            }
        }
    }

    function lock() {
        locked = true;
    }

    function unlock() {
        locked = false;
    }

    window.onpopstate = function (event) {
        go(event.state.route);
    };

    return {
        subscribe,
        go,
        setRoute,
        lock,
        unlock
    }

}

/***/ }),

/***/ "./js/lib/andy.uid.js":
/*!****************************!*\
  !*** ./js/lib/andy.uid.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function () {
    let assigned = [];

    function generate() {
        let uid;
        do {
            uid = Math.random().toString(36).substring(2) + parseInt(performance.now()).toString(36);
        } while (assigned.indexOf(uid) >= 0);
        assigned.push(uid);
        return uid;
    }

    return {
        generate
    }
}

/***/ }),

/***/ "./js/lib/andy.utils.js":
/*!******************************!*\
  !*** ./js/lib/andy.utils.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
    formatBytes: (mbytes, decimals) => {
        if (mbytes == 0) return '0 Bytes';
        var k = 1024,
            dm = decimals || 2,
            sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(mbytes) / Math.log(k));
        return parseFloat((mbytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    loadCSSFile: (path, callback) => {
        var style = document.createElement('style');

        andy.Xhr.get(path, function (contents) {
            style.textContent = contents;
            document.body.appendChild(style);
        });
    },
    loadJSFile: (path, callback) => {
        var script = document.createElement('script');
        script.type = 'text/javascript';

        andy.Xhr.get(path, function (contents) {
            script.textContent = contents;

            document.body.appendChild(script);
            if (typeof callback != "undefined") {
                callback();
            }
        });
    },
    typeFromExtension: (fileName) => {
        var fileTypes = {
            'jpg': {
                type: 'image'
            },
            'jpeg': {
                type: 'image'
            },
            'bmp': {
                type: 'image'
            },
            'png': {
                type: 'image'
            },
            'gif': {
                type: 'image'
            },
            'mp4': {
                type: 'video'
            },
            'webm': {
                type: 'video'
            },
            'mp3': {
                type: 'audio'
            },
            'ogg': {
                type: 'audio'
            },
            'm4v': {
                type: 'video'
            },
            'spotsideads': {
                type: 'spotside-web-ad'
            },
            'woff': {
                type: 'font'
            },
            'ttf': {
                type: 'font'
            },
            'otf': {
                type: 'font'
            }
        }

        var fileExt = fileName.toLowerCase().split('.').pop();

        var keys = Object.keys(fileTypes);

        for (var i = 0; i < keys.length; i++) {
            if (fileExt == keys[i]) {
                return fileTypes[keys[i]].type;
            }
        }
        return 'unknown';
    },
    passwordStrength: (password, minLength) => {

        let score = 0;

        let counts = {
            numbers: [],
            upperCases: [],
            lowerCases: [],
            symbols: [],
        }

        password.split('').map(function (chr) {
            if (/\d/.test(chr)) {
                counts.numbers.push(chr);
                return;
            }
            if (/[A-Z]/.test(chr)) {
                counts.upperCases.push(chr);
                return;
            }
            if (/[a-z]/.test(chr)) {
                counts.lowerCases.push(chr);
                return;
            }
            if (/\W/.test(chr)) {
                counts.symbols.push(chr);
                return;
            }
        });


        if (password.length >= minLength) {

            if (counts.numbers.length > 0) {
                score += 10;
            }
            if (counts.upperCases.length > 0) {
                score += 10;
            }
            if (counts.lowerCases.length > 0) {
                score += 10;
            }
            if (counts.symbols.length > 0) {
                score += 10;
            }

            score += 20 + (password.length * 3);
        }

        return score;
    }
}


Array.prototype.move = function (old_index, new_index) {
    while (old_index < 0) {
        old_index += this.length;
    }
    while (new_index < 0) {
        new_index += this.length;
    }
    if (new_index >= this.length) {
        var k = new_index - this.length;
        while ((k--) + 1) {
            this.push(undefined);
        }
    }
    this.splice(new_index, 0, this.splice(old_index, 1)[0]);
    return this; // for testing purposes
};

/***/ }),

/***/ "./js/lib/andy.validators.js":
/*!***********************************!*\
  !*** ./js/lib/andy.validators.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
    notEmpty: function (value) {
        if (!value.trim()) {
            return false;
        }
        return true;
    },
    email: function (email) {
        var re = /^(([^<>()\[\]\\,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    minSize: function (value) {
        if (value.trim().length < 5) {
            return false;
        }
        return true;
    }
}

/***/ }),

/***/ "./js/lib/andy.xhr.js":
/*!****************************!*\
  !*** ./js/lib/andy.xhr.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
    get: (url, callback) => {
        let request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            var DONE = this.DONE || 4;
            if (this.readyState === DONE) {
                callback(this.response);
            }
        };
        request.open('GET', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send(null);
    },
    fetch: function (url, cb) {
        fetch(url).then(function (response) {
            response.json().then(function (res) {
                cb({ data: res, status: response.status })
            });
        }).catch(function (error) {
            cb({ status: error.status });
        });
    },
    post: function (url, data, cb) {
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }).then(function (response) {
            response.json().then(function (res) {
                cb({ data: res, status: response.status })
            });
            return response;
        }).catch(function (error) {
            cb({ status: error.status });
        });
    }
}



/***/ }),

/***/ "./js/lib/dom/dom.js":
/*!***************************!*\
  !*** ./js/lib/dom/dom.js ***!
  \***************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./element */ "./js/lib/dom/element.js");


const _tags = [
    'div',
    'h1',
    'h2',
    'h3',
    'button',
    'span',
    'li',
    'ul',
    'ol',
    'p',
    'a',
    'br',
    'video',
    'input',
    'label',
    'form',
    'textarea',
    'select',
    'img',
    'i',
    'embed',
    'canvas',
    'u',
    'td',
    'table',
    'th',
    'tbody',
    'thead',
    'strong',
    'option',
    'datalist'
]


_tags.forEach(tag => {
    window[tag.toUpperCase()] = function(className, innerHTML, value) {
        if (typeof className == 'object') {
            return new _element__WEBPACK_IMPORTED_MODULE_0__["HTMLElementWrapper"](className);
        }
        return new _element__WEBPACK_IMPORTED_MODULE_0__["HTMLElementWrapper"]({ tag, className, innerHTML, value });
    };
});

/***/ }),

/***/ "./js/lib/dom/element.js":
/*!*******************************!*\
  !*** ./js/lib/dom/element.js ***!
  \*******************************/
/*! exports provided: HTMLElementWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTMLElementWrapper", function() { return HTMLElementWrapper; });
function HTMLElementWrapper(p) {

    const props = {
        tag: 'div',
        className: null,
        innerHTML: null,
        value: null,
        ...p
    }

    const element = document.createElement(props.tag);

    function constructor() {
        Object.keys(props).forEach(key => {
            if (props[key]) element[key] = props[key];
        });
    }

    constructor();

    return element;

}

/***/ }),

/***/ "./js/lib/eventManager/eventManager.js":
/*!*********************************************!*\
  !*** ./js/lib/eventManager/eventManager.js ***!
  \*********************************************/
/*! exports provided: EventManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventManager", function() { return EventManager; });
function EventManager() {
    const events = {};

    function addEventListener(ev, cb) {
        ev.split(' ').forEach(event => {
            if (!events[event]) {
                events[event] = [];
            }
            events[event].push(cb);
        });
    }

    function dispatchEvent(ev, values) {
        ev.split(' ').forEach(event => {
            if (events[event]) {
                events[event].forEach(function(cb) {
                    cb(values);
                });
            }
        });
    }

    return {
        addEventListener,
        dispatchEvent,
        dispatch: dispatchEvent,
        on: addEventListener
    }
};

/***/ }),

/***/ "./js/main.js":
/*!********************!*\
  !*** ./js/main.js ***!
  \********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_dom_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/dom/dom */ "./js/lib/dom/dom.js");
/* harmony import */ var _ui_dropdown_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ui/dropdown/dropdown */ "./js/ui/dropdown/dropdown.js");
/* harmony import */ var _ui_modal_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ui/modal/modal */ "./js/ui/modal/modal.js");
/* harmony import */ var _ui_list_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ui/list/list */ "./js/ui/list/list.js");
/* harmony import */ var _lib_eventManager_eventManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/eventManager/eventManager */ "./js/lib/eventManager/eventManager.js");
/* harmony import */ var _ui_table_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ui/table/table */ "./js/ui/table/table.js");







let version = {
    name: 'Andy Framework',
    major: 0,
    minor: 2,
    build: 32,
    stable: false,
    get verisonString() {
        return `${this.major}.${this.minor}.${this.build}-${
      this.stable ? 'stable' : 'unstable'
      }`;
    }
};

console.log(
    `${version.name} | ${version.verisonString}`
);


let _andy = {
    debug: false,
    version,
    router: __webpack_require__(/*! ./lib/andy.router */ "./js/lib/andy.router.js")(),
    Auth: {},
    Language: __webpack_require__(/*! ./lib/andy.language */ "./js/lib/andy.language.js"),
    Comunication: {},
    Content: {},
    ContentConstraints: {},
    UI: {
        _instances: [],
        InputAutoComplete: __webpack_require__(/*! ./ui/andy.ui.autocomplete */ "./js/ui/andy.ui.autocomplete.js"),
        Button: __webpack_require__(/*! ./ui/andy.ui.button */ "./js/ui/andy.ui.button.js"),
        Chart: __webpack_require__(/*! ./ui/andy.ui.chart */ "./js/ui/andy.ui.chart.js"),
        CheckBox: __webpack_require__(/*! ./ui/andy.ui.checkbox */ "./js/ui/andy.ui.checkbox.js"),
        ColorPicker: __webpack_require__(/*! ./ui/andy.ui.colorpicker */ "./js/ui/andy.ui.colorpicker.js"),
        DatePicker: __webpack_require__(/*! ./ui/andy.ui.datepicker */ "./js/ui/andy.ui.datepicker.js"),
        DropDown: _ui_dropdown_dropdown__WEBPACK_IMPORTED_MODULE_1__["DropDown"],
        FileUploader: __webpack_require__(/*! ./ui/andy.ui.fileuploader */ "./js/ui/andy.ui.fileuploader.js"),
        Form: __webpack_require__(/*! ./ui/andy.ui.form */ "./js/ui/andy.ui.form.js"),
        // GFMSelect: require('./ui/andy.ui.gfmselect'),
        Group: __webpack_require__(/*! ./ui/andy.ui.group */ "./js/ui/andy.ui.group.js"),
        Icon: __webpack_require__(/*! ./ui/andy.ui.icon */ "./js/ui/andy.ui.icon.js"),
        Indicator: __webpack_require__(/*! ./ui/andy.ui.indicator */ "./js/ui/andy.ui.indicator.js"),
        Input: __webpack_require__(/*! ./ui/andy.ui.input */ "./js/ui/andy.ui.input.js"),
        Label: __webpack_require__(/*! ./ui/andy.ui.label */ "./js/ui/andy.ui.label.js"),
        List: __webpack_require__(/*! ./ui/andy.ui.list */ "./js/ui/andy.ui.list.js"),
        ListV2: _ui_list_list__WEBPACK_IMPORTED_MODULE_3__["List"],
        Modal: _ui_modal_modal__WEBPACK_IMPORTED_MODULE_2__["Modal"],
        RadioButton: __webpack_require__(/*! ./ui/andy.ui.radiobutton */ "./js/ui/andy.ui.radiobutton.js"),
        RichTextEditor: __webpack_require__(/*! ./ui/andy.ui.richtexteditor */ "./js/ui/andy.ui.richtexteditor.js"),
        Select: __webpack_require__(/*! ./ui/andy.ui.select */ "./js/ui/andy.ui.select.js"),
        SearchBox: __webpack_require__(/*! ./ui/andy.ui.searchbox */ "./js/ui/andy.ui.searchbox.js"),
        SlideBar: __webpack_require__(/*! ./ui/andy.ui.slidebar */ "./js/ui/andy.ui.slidebar.js"),
        Tags: __webpack_require__(/*! ./ui/andy.ui.tags */ "./js/ui/andy.ui.tags.js"),
        Tabs: __webpack_require__(/*! ./ui/andy.ui.tabs */ "./js/ui/andy.ui.tabs.js"),
        Switch: __webpack_require__(/*! ./ui/andy.ui.switch */ "./js/ui/andy.ui.switch.js"),
        Textarea: __webpack_require__(/*! ./ui/andy.ui.textarea */ "./js/ui/andy.ui.textarea.js"),
        TreeList: __webpack_require__(/*! ./ui/andy.ui.treelist */ "./js/ui/andy.ui.treelist.js"),
        GridList: __webpack_require__(/*! ./ui/andy.ui.gridlist */ "./js/ui/andy.ui.gridlist.js"),
        Menu: __webpack_require__(/*! ./ui/andy.ui.menu */ "./js/ui/andy.ui.menu.js"),
        Container: __webpack_require__(/*! ./ui/andy.ui.container */ "./js/ui/andy.ui.container.js"),
        Table: _ui_table_table__WEBPACK_IMPORTED_MODULE_5__["Table"],
        Datalist: __webpack_require__(/*! ./ui/andy.ui.datalist */ "./js/ui/andy.ui.datalist.js"),
        RetroSearchBox: __webpack_require__(/*! ./ui/andy.ui.retrosearchbox */ "./js/ui/andy.ui.retrosearchbox.js"),
        // Map: require('./ui/andy.ui.map')
    },
    Utils: __webpack_require__(/*! ./lib/andy.utils */ "./js/lib/andy.utils.js"),
    Xhr: __webpack_require__(/*! ./lib/andy.xhr */ "./js/lib/andy.xhr.js"),
    Validators: __webpack_require__(/*! ./lib/andy.validators */ "./js/lib/andy.validators.js"),
    Controllers: {},
    Login: null,
    Dataset: __webpack_require__(/*! ./lib/andy.dataset */ "./js/lib/andy.dataset.js"),
    data: __webpack_require__(/*! ./lib/andy.data */ "./js/lib/andy.data.js"),
    uid: __webpack_require__(/*! ./lib/andy.uid */ "./js/lib/andy.uid.js")(),
    EventManager: _lib_eventManager_eventManager__WEBPACK_IMPORTED_MODULE_4__["EventManager"],
    Object: __webpack_require__(/*! ./lib/andy.object */ "./js/lib/andy.object.js"),
    _datasets: {}
};


window.andy = _andy;

window.Container = andy.UI.Container;

/***/ }),

/***/ "./js/ui/andy.ui.autocomplete.js":
/*!***************************************!*\
  !*** ./js/ui/andy.ui.autocomplete.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {


//globals

let resultsWrapper = new DIV('andy-ui-autocomplete-results-wrapper');
document.body.appendChild(resultsWrapper);

resultsWrapper.show = function (el) {
    let rects = el.getBoundingClientRect();
    this.style.top = rects.bottom + 'px';
    this.style.left = rects.left + 'px';
    this.style.width = rects.width + 'px';
    this.classList.add('show');
}

resultsWrapper.hide = function () {
    this.classList.remove('show');
}

//andy.UI.InputAutoComplete
module.exports = function (options) {
    let hasResult = false;
    let value = null;
    let el = new INPUT('andy-ui-input');

    stdOptions = {
        dataset: null,
        searchField: 'name',
        labelField: 'name',
        valueField: '_id',
        minChars: 2,
        normalizeFunction: function (term) {
            return term.toLowerCase().trim();
        },
        renderItem: function (result, term) {
            term = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            let re = new RegExp("(" + term.split(' ').join('|') + ")", "gi");
            let element = new DIV('result-item', result[options.labelField].replace(re, "<b>$1</b>"));

            return {
                element,
                value: result[options.valueField],
                label: result[options.searchField]
            };
        },
        searchFunction: function (term) {
            let results = [];
            Object.values(options.dataset.data).forEach(function (item) {
                if (options.normalizeFunction(item[options.searchField]).includes(options.normalizeFunction(term))) {
                    results.push(item);
                }
            });
            return results;
        }
    }

    options = { ...stdOptions, ...options };

    function search(term) {
        resultsWrapper.innerHTML = '';
        let results = options.searchFunction(term);
        results.forEach(function (result) {
            let item = options.renderItem(result, term);
            item.element.addEventListener('click', function () {
                value = item.value;
                el.value = item.label;
                resultsWrapper.hide();
                hasResult = true;
            })
            resultsWrapper.append(item.element);
        });
        if (results.length > 0) {
            resultsWrapper.show(el);
        } else {
            value = el.value;
        }
    }

    el.addEventListener('keyup', function () {
        hasResult = false;
        if (this.value.length > options.minChars - 1) {
            search(this.value);
        } else {
            resultsWrapper.hide();
        }
    });

    el.addEventListener('blur', function () {
        setTimeout(function () { resultsWrapper.hide() }, 250);
    });

    let public = {
        get hasResultSelected() {
            return hasResult;
        },
        reset: function () {
            el.value = '';
            value = '';
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: function (val) {
            hasResult = false;
            value = val;
            if (options.dataset) {
                if (options.dataset.data[val]) {
                    el.value = options.dataset.data[val][options.labelField];
                    hasResult = true;
                } else {
                    el.value = val;
                }
            } else {
                el.value = val;
            }
        },
        bind: function () { console.info('Not implemented yet: checkbox.bind()'); },
        on: function () { console.info('Not implemented yet: checkbox.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}



/***/ }),

/***/ "./js/ui/andy.ui.button.js":
/*!*********************************!*\
  !*** ./js/ui/andy.ui.button.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options, callback) {

    let el = new DIV('andy-ui-button');
    let icon, label;
    let disabled = false;

    function hide() {
        el.classList.add('hide');
    }

    function show() {
        el.classList.remove('hide');
    }

    function disable() {
        el.classList.add('disabled');
        disabled = true;
    }

    function enable() {
        el.classList.remove('disabled');
        disabled = false;
    }

    if (options.icon) {
        icon = (typeof options.icon === 'string') ? new andy.UI.Icon(options.icon) : new andy.UI.Icon(...Object.values(options.icon));

        icon.on('re-render', () => { 
            const prevIcon = el.querySelector('.andy-ui-icon');

            if (prevIcon) {
                el.removeChild(prevIcon);
                el.append(icon.getElement())
            }
        });

        el.append(icon.getElement());
    }

    if (options.label) {
        label = (typeof options.label === 'string') ? new andy.UI.Label(options.label) : new andy.UI.Label(...Object.values(options.label));
        el.append(label.getElement());
    }

    if (options.disabled) {
        disable();
    }

    if (options.customClass) {
        el.classList.add(options.customClass);
    }

    function clickHandler(e) {
        e.stopPropagation();
        if (!disabled) {
            if (callback) callback(public);
        }
    }

    el.addEventListener('click', clickHandler);

    let public = {
        get element(){
            return el;
        },
        get icon() {
            return icon;
        },
        get label() {
            return label;
        },
        getElement: function () {
            return el;
        },
        disable,
        enable,
        hide,
        show,
        getState: function () {

        },
        setState: function (state) {
            if (state) {
                el.classList.add(state);
                if (options.states) {
                    if (options.states[state]) {
                        let s = options.states[state];
                        if (typeof s.icon === 'string') {
                            icon.setValue(s.icon);
                        } else {
                            icon.setValue(...Object.values(s.icon));
                        }
                        if (typeof s.label === 'string') {
                            label.setValue(s.label);
                        } else {
                            label.setValue(...Object.values(s.label));
                        }
                    }
                }
            } else {
                el.className = 'andy-ui-button';

                if (typeof options.icon === 'string') {
                    icon.setValue(options.icon);
                } else {
                    icon.setValue(...Object.values(options.icon));
                }
                if (typeof options.label === 'string') {
                    label.setValue(options.label);
                } else {
                    label.setValue(...Object.values(options.label));
                }
            }
        },
        bind: function () {
            console.info('Not implemented yet: button.bind()');
        },
        on: function () {
            console.info('Not implemented yet: button.on()');
        }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.chart.js":
/*!********************************!*\
  !*** ./js/ui/andy.ui.chart.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options, data) { // this component needs revision
    let el = new DIV('andy-ui-chart');

    let label = new andy.UI.Label(options.label);
    let contentEl = new DIV('content');
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    contentEl.append(canvas);
    let footerEl = new DIV('footer');
    let chart;

    el.append(label.getElement(), contentEl, footerEl);

    function createChart() {
        chart = new Chart(ctx, {
            type: options.type,
            data: data,
            options: {
                responsive: true,
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false,
                        },
                        ticks: {
                            fontColor: "white", // this here
                        },
                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: false,
                        },
                    }],
                }
            }
        });
    }

    createChart()

    let public = {
        getElement: function () {
            return el;
        },
        bind: function () { console.info('Not implemented yet: label.bind()'); },
        on: function () { console.info('Not implemented yet: label.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.checkbox.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.checkbox.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (value) {
    value = (typeof value !== 'undefined') ? value : false;

    let scope = this;
    let el = new DIV('andy-ui-checkbox');
    let pin = new SPAN('pin mdi mdi-check');
    let events = {};

    el.append(pin);
    el.addEventListener('click', toggle);

    function toggle() {
        if (value) {
            value = false;
        } else {
            value = true;
        }
        toggleClass();
        el.value = value;
        if (events.change) {
            events.change(public);
        }
    }

    function toggleClass() {
        if (!value) {
            el.classList.remove('selected');
        } else {
            el.classList.add('selected');
        }
    }

    let public = {
        value: value,
        reset: function () {
            value = false;
            el.value = false;
            toggleClass();
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        returnValue: function () { // Deprecated
            return value;
        },
        setValue: function (v) {
            value = v;
            toggleClass();
        },
        toggle: toggle,
        bind: function () {
            console.info('Not implemented yet: checkbox.bind()');
        },
        on: function (event, callback) {
            events[event] = callback;
        }
    }

    el.setValue = public.setValue; //added for back compatibility

    toggleClass();

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.colorpicker.js":
/*!**************************************!*\
  !*** ./js/ui/andy.ui.colorpicker.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

let pickerModalWrapper = new DIV('andy-ui-colorpicker-wrapper');
let pickerModal = new DIV('andy-ui-colorpicker-modal');
pickerModal.show = function (pointer) {



    let size = pickerModal.getBoundingClientRect();

    let pos = {
        x: pointer.clientX,
        y: pointer.clientY
    }

    if (pos.x > window.innerWidth / 2) {
        this.style.left = (pos.x - size.width) + 'px';
    } else {
        this.style.left = pos.x + 'px';
    }
    if (pos.y > window.innerHeight / 2) {
        this.style.top = (pos.y - size.height) + 'px';
    } else {
        this.style.top = pos.y + 'px';
    }

    pickerModalWrapper.classList.add('show');
    this.classList.add('show');
    this.getElementsByTagName('input')[0].className = 'andy-ui-input';


}


pickerModalWrapper.addEventListener('click', function () {
    pickerModal.hide();
});


pickerModal.hide = function () {
    this.classList.remove('show');
    pickerModalWrapper.classList.remove('show');
}

document.body.appendChild(pickerModalWrapper);
document.body.appendChild(pickerModal);

let picker;

// andy.UI.ColorPicker 
module.exports = function (val, callback) {

    if (!picker) {
        picker = new Picker({
            parent: pickerModal,
            popup: false,
            layout: 'default',
            alpha: true,
            editor: true,
            color: 'rgba(255,255,255,1.00)',
            onDone: function (color) {
                pickerModal.hide();
            }
        });
    }

    let value = 'rgba(255,255,255,1.00)';

    let rawValue = null;

    let el = new DIV('andy-ui-colorpicker');

    let label = new andy.UI.Label('');

    let previewButton = new DIV('color-preview-button');

    previewButton.setColor = function (val) {
        this.style.backgroundColor = val;
    }

    el.append(previewButton);

    previewButton.addEventListener('click', function (e) {
        pickerModal.show(e);
        picker.setOptions({
            onChange: function (color) {
                rawValue = color;
                previewButton.setColor(color.rgbaString);
                if (callback) {
                    callback(color.rgbaString, color);
                }
                label.setValue(color.rgbaString);
                value = color.rgbaString;
            }
        });
        picker.setColor(value);
    });

    function setValue(val) {
        previewButton.setColor(val);
        label.setValue(val);
        value = val;
    }

    if (val) {
        setValue(val);
    } else {
        setValue(value);
    }

    function lock() {
        previewButton.classList.add('locked');
    }

    function unlock() {
        previewButton.classList.remove('locked');
    }

    let public = {
        reset: function () {
            setValue('#FFF');
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        getColor: function () {
            return rawValue;
        },
        lock,
        unlock,
        setValue: setValue,
        bind: function () { console.info('Not implemented yet: checkbox.bind()'); },
        on: function () { console.info('Not implemented yet: checkbox.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}


/***/ }),

/***/ "./js/ui/andy.ui.container.js":
/*!************************************!*\
  !*** ./js/ui/andy.ui.container.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

let _containers = {};

module.exports = function(options) {

    const mainEvents = new andy.EventManager();

    let defaultOptions = {
        code: null,
        route: null,
        transitionClass: 'fade',
        activeDelay: 200,
        wrapper: true,
        styleClass: null
    };

    options = {...defaultOptions, ...options };

    if (options.code) {
        // find code & return if existent
        if (_containers[options.code]) {
            return _containers[options.code];
        }
    } else {
        // create unique code
        options.code =
            Date.now().toString() + Object.keys(_containers).length.toString();
    }

    if (options.route === null) {
        options.route = '/' + options.code;
    }

    if (options.wrapper) {
        if (typeof options.wrapper == 'boolean') {
            options.wrapper = new DIV('andy-ui-container-wrapper');
        }

        if (options.styleClass) {
            options.wrapper.classList.add(options.styleClass);
        }
    }

    let views = {};

    function hideAll(exceptionKey = null) {
        mainEvents.dispatchEvent('view.change', exceptionKey);
        Object.keys(views).forEach(function(viewKey) {
            if (exceptionKey) {
                if (viewKey != exceptionKey) {
                    views[viewKey].hide();
                }
            } else {
                views[viewKey].hide();
            }
        });
    }

    function newView(opt) {
        let events = new andy.EventManager();

        let defaultOpt = {
            element: null,
            transitionClass: options.transitionClass,
            activeDelay: options.activeDelay,
            active: false,
            route: null,
            code: null
        };

        opt = {...defaultOpt, ...opt };

        if (!opt.element) {
            opt.element = new DIV('andy-ui-container');
        } else {
            if (typeof opt.element == 'string') {
                opt.code = opt.element;
                opt.element = document.getElementById(opt.element);
                opt.element.classList.add('andy-ui-container');
            } else {
                opt.element.classList.add('andy-ui-container');
            }
        }
        opt.element.style.pointerEvents = 'none';
        // opt.element.style.display = 'none';
        opt.element.classList.add(opt.transitionClass);

        if (!opt.code) {
            opt.code = andy.uid.generate();
        }

        if (!opt.route) {
            opt.route = '/' + opt.code;
        }

        function show(conf) {
            let defaults = {
                fromRouter: false,
                routeStop: false,
                route: null,
                stopProp: false
            };

            conf = {...defaults, ...conf };

            hideAll(opt.code);
            // opt.element.style.display = '';
            options.wrapper.append(opt.element);

            opt.active = true;
            events.dispatchEvent('enter');
            if (!conf.stopProp) {
                events.dispatchEvent('show');
            }
            if (andy.router && opt.route) {
                if (!conf.fromRouter || conf.routeStop) {
                    if (conf.route != options.route + opt.route) {
                        andy.router.setRoute(options.route + opt.route);
                    }
                }
            }
            setTimeout(function() {
                opt.element.classList.add('show');
                opt.element.style.pointerEvents = 'all';
            }, opt.activeDelay);
        }

        function hide(conf) {
            let defaults = {
                stopProp: false
            };

            conf = {...defaults, ...conf };

            opt.element.classList.remove('show');

            if (opt.active) {
                events.dispatchEvent('leave');
            }

            opt.active = false;


            if (conf.stopProp) {
                events.dispatchEvent('hide');
            }
            opt.element.style.pointerEvents = 'none';
            setTimeout(function() {
                opt.element.remove();
                // opt.element.style.display = 'none';
            }, opt.activeDelay);
        }

        // Pedro Rodrigues @6/2/19 - show & hide functions in the element just for compatibility with old code
        opt.element.show = function() {
            show();
        };
        opt.element.hide = function() {
            hide();
        };

        if (andy.router && opt.route) {
            andy.router.subscribe(options.route + opt.route, function(
                routeStop,
                route
            ) {
                show({ fromRouter: true, routeStop, route });
            });
        }

        function append() {
            opt.element.append(...arguments);
        }

        let view = {
            ...opt,
            show,
            hide,
            append,
            on: events.addEventListener
        };

        views[opt.code] = view;

        if (options.wrapper) {
            options.wrapper.append(opt.element);
        }

        return {
            ...view,
            show: function() {
                show(...arguments);
            },
            hide: function() {
                hide(...arguments);
            }
        };
    }

    function add(elementID, callbacks, name, route) {
        // Pedro Rodrigues @ 6/2/19 - this function is just for compatibility
        let view = newView({
            code: name,
            element: elementID,
            route
        });

        if (callbacks) {
            if (callbacks.onEnter) {
                view.on('enter', callbacks.onEnter);
            }
            if (callbacks.leave) {
                view.on('leave', callbacks.onLeave);
            }
        }

        return view;
    }

    function show(code) {
        if (views[code]) {
            views[code].show();
        }
    }

    function showFirst() {
        let keys = Object.keys(views);

        if (keys.length > 0) {
            views[keys[0]].show();
        }
    }

    function getElements() {
        let elements = Object.values(views).map(function(view) {
            return view.element;
        });

        return elements;
    }

    function getElement() {
        return options.wrapper;
    }

    let public = {
        show,
        showFirst,
        add,
        newView,
        getElement,
        get elements() {
            return getElements();
        },
        on: mainEvents.addEventListener
    };

    _containers[options.code] = public;

    return public;
};

/***/ }),

/***/ "./js/ui/andy.ui.datalist.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.datalist.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (p) {

    const events = new andy.EventManager();
    const props = {
        id: `default-${andy.uid.generate()}`,
        options: [],
        nullOption: 'no_group',
        ...p
    }

    let el;

    function constructor() {
        el = new DATALIST('datalist');

        if (props) {
            if (props.id != null) {
                el.setAttribute('id', props.id)
            }

            if (props.options && props.options.length) {
                for (let i = 0; i < props.options.length; i++) {
                    if (props.options[i] !== props.nullOption) {
                        const option = new OPTION('', props.options[i], props.options[i])
                        el.append(option);
                    }
                }
            }
        }
    }

    function addOptions(dataset, key) {
        const data = dataset.data ? dataset.data : dataset;
        const values = new Set([...Object.values(data).map(o => o[key])]);
        props.options = [...values];
        el.innerHTML = '';

        for (let i = 0; i < props.options.length; i++) {
            if (props.options[i] !== props.nullOption) {
                const option = new OPTION('', props.options[i], props.options[i])
                el.append(option);
            }
        }
    }

    constructor();

    const _public = {
        set options(o) {
            props.options = [...o];
        },
        get options() {
            return props.options;
        },
        get id() {
            return props.id;
        },
        get element() {
            return el;
        },
        getElement() {
            return el
        },
        bind: function (dataset, key) { 
            if (!dataset || !key) {
                return false;
            }

            addOptions(dataset, key);
    
            dataset.on('fetch', ({ dataset }) => addOptions(dataset, key));
            dataset.on('remove', () => dataset.fetch());
            dataset.on('save', () => dataset.fetch());
        },
        on: events.addEventListener
    }

    andy.UI._instances.push(_public);
    return _public;
}

/***/ }),

/***/ "./js/ui/andy.ui.datepicker.js":
/*!*************************************!*\
  !*** ./js/ui/andy.ui.datepicker.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (date, options = {}) {

    let el = new INPUT('andy-ui-input');

    let picker = flatpickr(el, options);

    function setValue(val) {
        picker.setDate(new Date(val));
    }

    if (date) {
        setValue(val);
    }

    function lock() {
        el.classList.add('locked');
    }

    function unlock() {
        el.classList.remove('locked');
    }

    let public = {
        reset: function () {
            el.value = '';
            picker.clear();
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return el.value;
        },
        lock, 
        unlock,
        setValue
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.fileuploader.js":
/*!***************************************!*\
  !*** ./js/ui/andy.ui.fileuploader.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) {

    let defaults = {
        origin: performance.now().toString(),
        accept: '.png,.jpg,.jpeg,.svg,.pdf,.spotsideads',
        drop: true
    }

    options = Object.assign({}, defaults, options);

    let file = null;

    let el = new DIV('andy-ui-fileuploader');



    let messageCode = (options.drop) ? 'click_or_drop_to_upload' : 'click_to_upload';
    let label = new andy.UI.Label(messageCode);

    function reset() {
        file = null;
        label.setValue(messageCode);
        el.style.backgroundImage = 'none';
        el.classList.remove('withfile');
    }

    let removeButton = new andy.UI.Button({ icon: 'delete', label: '' }, reset);

    el.append(label.getElement(), removeButton.getElement());

    let uploader = new SocketIOFileUpload(socket);

    let upload = document.createElement('input');
    upload.type = 'file';
    upload.accept = options.accept;

    upload.onchange = function () {
        uploader.submitFiles(upload.files);
    };

    uploader.addEventListener("start", function (event) {
        event.file.meta.origin = options.origin;
    });

    el.addEventListener('click', function () {
        upload.click();
    });

    socket.on(options.origin, (data) => {
        switch (data.action) {
            case 'uploaded':
                set(data.value.filename);
                break;
        }
    });

    function set(value) {
        file = value;
        el.style.backgroundImage = "url('data/thumbnails/" + value + "')";
        label.setValue(value);
        el.classList.add('withfile');
    }


    let public = {
        clear: reset, // Pedro Rodrigues @ 17 / 1 / 19 - TODO : check if there are any code using the clear function 
        reset,
        getElement: function () {
            return el;
        },
        getValue: function () {
            return file;

        },
        setValue: function (value) {
            if (value) {
                reset();
                set(value);
            } else {
                reset();
            }
        },
        // bind: function() { console.info('Not implemented yet: form.bind()'); },
        // on: function() { console.info('Not implemented yet: form.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.form.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.form.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (title, fields, buttons, headerButtons, options) {

	let items = {};

	let el = new DIV('andy-ui-form');
	let header = new DIV('header');
	let content = new DIV('content');
	let footer = new DIV('footer');
	el.append(header, content, footer);

	let headerLabel = new andy.UI.Label(!title ? '' : title);
	header.append(headerLabel.getElement());

	let headerGroup = new andy.UI.Group(headerButtons, {
		style: { justifyContent: 'flex-end' }
	});

	if (headerButtons) {
		header.append(headerGroup.getElement());
	}

	let footerGroup = new andy.UI.Group(buttons);

	if (buttons) {
		footer.append(footerGroup.getElement());
	}

	function hide() {
		el.classList.add('hide');
	}

	function show() {
		el.classList.remove('hide');
	}

	function addField(code, labelText, item, required, descriptionText, filter = null) {
		let el = new DIV('field');
		let labelWrapper = new DIV('label-wrapper');
		let fieldWrapper = new DIV('field-wrapper');
		let descriptionWrapper = new DIV('description-wrapper');

		let label = null;

		if (labelText) {
			label = new andy.UI.Label(labelText, { customClass: 'form-label' });
			labelWrapper.append(label.getElement());

			if (required) {
				let req = new DIV('required', '*');
				labelWrapper.append(req);
			}

			el.append(labelWrapper);
		}

		fieldWrapper.append(item.getElement());
		el.append(fieldWrapper);

		let description = null;

		if (descriptionText) {
			description = new andy.UI.Label(descriptionText, { customClass: 'form-description' });
			descriptionWrapper.append(description.getElement());
			el.append(descriptionWrapper);
		}


		function remove() {
			el.remove();
		}

		function append() {
			content.append(el);
		}

		items[code] = {
			label,
			item,
			filter,
			required: !required ? false : required,
			description: description,
			remove,
			append
		};


		append();
	}

	function applyFilter(filter) {
		Object.values(items).forEach(item => {
			if (item.filter) {
				if (Array.isArray(item.filter)) {
					if (item.filter.includes(filter)) {
						item.append();
					} else {
						item.remove();
					}
				} else {
					if (item.filter == filter) {
						item.append();
					} else {
						item.remove();
					}
				}
			}
		})
	}

	function init() {
		if (fields) {
			Object.keys(fields).forEach(function (key) {
				let field = fields[key];
				addField(key, field.label, field.item, field.required, field.description, field.filter);
			});
		}
	}

	if (options) {
		if (typeof options.init == 'undefined') {
			init();
		} else {
			if (options.init) {
				init();
			}
		}
	} else {
		init();
	}

	function reset() {
		Object.keys(items).forEach(function (key) {
			if (items[key]) {
				let field = items[key];
				if (field.item.reset) {
					field.item.reset();
				}
			}
		});
	}

	function validate() {
		let valid = true;
		const keys = Object.keys(items);
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			if (items[key]) {
				let field = items[key];
				if (field.item.validate) {
					if (field.item.validate() == false) {
						valid = false;
					}
				}
			}
		}
		return valid;
	}

	function lock() {
		Object.keys(items).forEach(function (key) {
			if (items[key]) {
				const field = items[key];
				if (field.item.lock) {
					field.item.lock();
				}
			}
		});
	}

	function unlock() {
		Object.keys(items).forEach(function (key) {
			if (items[key]) {
				const field = items[key];
				if (field.item.unlock) {
					field.item.unlock();
				}
			}
		});
	}

	let public = {
		get element() {
			return el;
		},
		items: items,
		reset,
		validate,
		buttons: footerGroup,
		footerGroup,
		headerGroup,
		title: headerLabel,
		init: init,
		hide,
		show,
		setTitle: function (title) {
			headerLabel.setValue(title); // back compatibility
		},
		clear: function () {
			items = {};
			content.innerHTML = '';
		},
		add: addField,
		getElement: function () {
			return el;
		},
		getValue: function () {
			let values = {};
			Object.keys(items).forEach(function (key) {
				let field = items[key];
				if (!!field.item.getValue) {
					values[key] = field.item.getValue();
				}
			});
			return values;
		},
		setValue: function (values) {
			Object.keys(values).forEach(function (key) {
				if (!!items[key]) {
					let field = items[key];
					if (!!field.item.setValue) {
						field.item.setValue(values[key]);
					}
				}
			});
		},
		applyFilter,
		lock,
		unlock,
		bind: function () {
			console.info('Not implemented yet: form.bind()');
		},
		on: function () {
			console.info('Not implemented yet: form.on()');
		}
	};

	andy.UI._instances.push(public);
	return public;
};


/***/ }),

/***/ "./js/ui/andy.ui.gridlist.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.gridlist.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) {
	let wrapper = new DIV('andy-ui-gridlist');
	let groups = {};
	let items = {};
	let events = {};

	function template(item, render) {
		let el = new andy.UI.Label(item.name ? item.name : 'item');
		render(el.getElement());
		return item;
	}

	let defaultOptions = {
		template,
		type: 'normal',
		defaultKey: '_id',
		groupFunction: null,
		mode: 'normal',
		groupTemplate: null,
		sort: null,
		placeholder: 'no_data_to_show'
	};

	options = { ...defaultOptions, ...options };

	function constructor() {
		if (options.placeholder) {
			const placeholder = new andy.UI.Label(options.placeholder, { customClass: 'placeholder' });
            wrapper.append(placeholder.getElement());
		}
	}

	function sortItems(sortFilter) {
		let sortFn = options.sort.find(function (element) {
			return element.label == sortFilter;
		}).sort;

		if (typeof items == 'object') {
			items = Object.values(items).sort(sortFn);
		} else {
			items = items.sort(sortFn);
		}
		const newItems = [...items];
		clear();
		newItems.forEach(i => addItem(i.item));
	}

	if (options.style) {
		Object.keys(options.style).forEach(function (key) {
			wrapper.style[key] = options.style[key];
		});
	}

	if (options.groupFunction) {
		wrapper.classList.add('groups');
	}

	function addItem(item) {
		let selectable =
			options.mode == 'select' || options.mode == 'multiple-select'
				? true
				: false;

		let obj = {
			item,
			selected: false,
			hide: function () {
				this.element.classList.add('hide');
			},
			show: function () {
				this.element.classList.remove('hide');
			},
			select: function () {
				if (selectable) {
					this.element.classList.add('selected');
					this.selected = true;
					if (options.mode == 'select') {
						deselectAll(item[options.defaultKey]);
					}
				}
			},
			deselect: function () {
				this.element.classList.remove('selected');
				this.selected = false;
			},
			selectable: function (on) {
				if (on) {
					selectable = true;
				} else {
					selectable = false;
					this.deselect();
				}
			}
		};

		function render(element) {
			obj.element = element;
			element.classList.add('tile');

			element.addEventListener('click', function () {
				if (selectable) {
					if (obj.selected) {
						obj.deselect();
					} else {
						obj.select();
					}
				}
			});

			if (options.groupFunction) {
				addToGroup(options.groupFunction(item), element, item);
			} else {
				wrapper.append(element);
			}
		}

		obj.value = options.template(item, render);
		let code = null;
		if (obj.value) {
			if (obj.value[options.defaultKey]) {
				code = obj.value[options.defaultKey];
			}
		}
		if (!code) {
			code = andy.uid.generate();
		}

		items[code] = obj;
	}

	function createGroup(groupCode) {
		let group = {
			code: groupCode,
			label: new andy.UI.Label(groupCode),
			element: new DIV('content')
		};

		let groupHeader = new DIV('header');
		groupHeader.append(group.label.getElement());

		let groupWrapper = new DIV('group-wrapper');
		groupWrapper.append(groupHeader, group.element);

		wrapper.append(groupWrapper);
		return group;
	}

	function addToGroup(groupCode, element, item) {
		if (!groups[groupCode]) {

			if (options.groupTemplate) {
				groups[groupCode] = options.groupTemplate(groupCode, wrapper)
			}
			else {
				groups[groupCode] = createGroup(groupCode);
			}

			groups[groupCode].items = [];

			if (events.groupAdded) {
				events.groupAdded(groupCode);
			}
		}
		groups[groupCode].element.append(element);
		groups[groupCode].items.push(item);
	}

	function addItems(items) {
		if (typeof items == 'object') {
			Object.values(items).forEach(addItem);
		} else {
			items.forEach(addItem);
		}
	}

	function changeMode(mode) {
		switch (mode) {
			case 'normal':
				Object.values(items).forEach(item => item.selectable(false));
				break;
			case 'select':
				Object.values(items).forEach(item => item.selectable(true));
				break;
			case 'multiple-select':
				Object.values(items).forEach(item => item.selectable(true));
				break;
		}
		options.mode = mode;
	}

	function getValue() {
		if (options.mode == 'normal') {
			return items;
		} else {
			return Object.values(items)
				.filter(item => item.selected)
				.map(item => {
					return item.value;
				});
		}
	}

	function setValue() { }

	function removeItem(key) {
		if (items[key].element) {
			items[key].element.remove();
			delete items[key];
		}
	}

	function getItems() { return items; }

	function clear() {
		Object.keys(items).forEach(removeItem);
		items = {};
		Object.keys(groups).forEach(item => {
			if (events.groupRemoved) events.groupRemoved(item);
			groups[item].element.remove();

			if (groups[item].header != null) {
				groups[item].header.remove();
			}

			if (groups[item].label && groups[item].label.getElement()){
				let groupWrapper = groups[item].label.getElement().parentElement.parentElement;
				if (groupWrapper && groupWrapper.parentElement) {
					groupWrapper.parentElement.removeChild(groupWrapper);
				}
			}

			delete groups[item];
		});
	}

	function bind(_dataset) {
		// Bind to a dataset

		if(Object.values(_dataset.data).length > 0){
			addItems(Object.values(_dataset.data));
		}

		_dataset.on('fetch', function ({ dataset }) {
			clear();
			addItems(Object.values(dataset));
		});

		_dataset.on('remove', function ({ document }) {
			removeItem(document[options.defaultKey]);
		});

		_dataset.on('save', function ({ document }) {
			clear();
			_dataset.fetch();
		});
	}

	function deselectAll(exceptionKey = null) {
		Object.keys(items).forEach(function (itemKey) {
			if (exceptionKey) {
				if (itemKey != exceptionKey) {
					items[itemKey].deselect();
				}
			} else {
				items[itemKey].deselect();
			}
		});
	}

	function search(value, key, normalize = false) {
		function normalizeStr(val) {
			if (normalize) {
				return val.toLowerCase().trim();
			}
			return val;
		}

		if (value.trim()) {
			Object.values(items).forEach(function (item) {
				if (normalizeStr(item.item[key]).includes(normalizeStr(value))) {
					item.show();
				} else {
					item.hide();
				}
			});
		} else {
			Object.values(items).forEach(function (item) {
				item.show();
			});
		}
	}

	constructor();

	let Public = {
		getElement: function () {
			return wrapper;
		},
		clear,
		removeItem,
		getValue,
		setValue,
		addItem,
		addItems,
		getItems,
		bind,
		search,
		deselectAll,
		changeMode,
		sortItems,
		on: function (event, callback) {
			events[event] = callback;
		},
		getItemsFromGroup: code => groups[code].items
	};

	andy.UI._instances.push(Public);
	return Public;
};


/***/ }),

/***/ "./js/ui/andy.ui.group.js":
/*!********************************!*\
  !*** ./js/ui/andy.ui.group.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(components, options = {}) {

    let defaultOptions = {
        hidden: false,
        customClass: null
    };

    options = {...defaultOptions, ...options };

    let items = {};
    let el = new DIV('andy-ui-group');

    if (options.customClass) {
        el.classList.add(options.customClass);
    }

    if (options.style) {
        Object.keys(options.style).forEach(function(key) {
            el.style[key] = options.style[key];
        });
    }

    if (options.hidden) {
        hide();
    }

    function addItem(code, item) {
        items[code] = item;
        el.append(item.getElement());
    }

    function getValueAsObject() {
        let values = {};
        Object.keys(items).forEach(function(key) {
            let item = items[key];
            if (item.getValue) {
                values[key] = item.getValue();
            }
        });
        return values;
    }

    function getValueAsArray() {
        let values = [];
        Object.keys(items).forEach(function(key) {
            if (items[key]) {
                let item = items[key];
                if (item.getValue) {
                    values.push(item.getValue());
                }
            }
        });
        return values;
    }

    function setValueAsObject(values) {
        Object.keys(values).forEach(function(key) {
            if (items[key]) {
                let item = items[key];
                if (item.setValue) {
                    item.setValue(values[key]);
                }
            }
        });
    }

    function setValueAsArray(values) {
        Object.keys(items).map(function(key, index) {
            let item = items[key];
            if (item.setValue) {
                item.setValue(values[index]);
            }
        })
    }

    function hide() {
        el.classList.add('hide');
        options.hidden = true;
    }

    function show() {
        el.classList.remove('hide');
        options.hidden = false;
    }


    if (components) {
        Object.keys(components).forEach(function(key) {
            addItem(key, components[key]);
        });
    }

    let public = {
        items: items,
        add: addItem,
        get element() {
            return el;
        },
        getElement: function() {
            return el;
        },
        clear: function() {
            Object.keys(items).forEach(function(key) {
                items[key].getElement().remove();
                delete items[key];
            });
        },
        getValue: function() {
            if (options.toArray) {
                return getValueAsArray();
            } else {
                return getValueAsObject();
            }
        },
        setValue: function(values) {
            if (options.toArray) {
                return setValueAsArray(values);
            } else {
                return setValueAsObject(values);
            }
        },
        hide,
        show,
        bind: function() { console.info('Not implemented yet: group.bind()'); },
        on: function() { console.info('Not implemented yet: group.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.icon.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.icon.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (_value, type, options) {

    const events = new andy.EventManager();
    let value = _value;

    type = (!type) ? 'mdi' : type;
    let el;

    function renderIcon() {
        switch (type) {
            case 'mdi':
                renderMDIcon();
                break;

            case 'material':
                renderMaterialIcon();
                break;

            case 'image':
                renderImageIcon();
                break;
        }

        events.dispatchEvent('re-render');

        if (options) {
            if (options.disabled) {
                el.classList.add('disabled');
            }
        }
    }

    function renderMDIcon() {
        el = new SPAN(`andy-ui-icon mdi ${value}`, '');
    }


    function renderMaterialIcon() {
        el = new ICON('andy-ui-icon material-icons', value);
    }

    function renderImageIcon() {
        el = new DIV('andy-ui-icon image', '');
        el.style.backgroundImage = "url('" + value + "')";
    }

    let public = {
        get element(){
            return el;
        },
        value: value,
        type: type,
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: function (v, t) {
            if (!!t) {
                type = t;
            }
            value = v;
            renderIcon();
        },
        bind: function () { console.info('Not implemented yet: icon.bind()'); },
        on: events.on,
    }

    andy.UI._instances.push(public);
    renderIcon();

    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.indicator.js":
/*!************************************!*\
  !*** ./js/ui/andy.ui.indicator.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) { // this component needs revision
    let el = new DIV('andy-ui-indicator');

    let label = new andy.UI.Label(options.label);
    let contentEl = new DIV('content', options.value);
    let footerEl = new DIV('footer');

    el.append(label.getElement(), contentEl, footerEl);

    let public = {
        value: options.value,
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: function (v) {
            options.value = v;
            contentEl.innerHTML = v;
        },
        bind: function () { console.info('Not implemented yet: label.bind()'); },
        on: function () { console.info('Not implemented yet: label.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.input.js":
/*!********************************!*\
  !*** ./js/ui/andy.ui.input.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) {

    let events = new andy.EventManager();


    let el;
    let validators = [];
    let touched = false;

    function constructor() {

        el = new INPUT('andy-ui-input');

        el.addEventListener('focus', focusHandler);
        el.addEventListener('blur', blurHandler);
        el.addEventListener('change', changeHandler);


        if (options) {

            if (options.validators) {
                if (typeof options.validators === 'function') {
                    addValidators(options.validators);
                } else {
                    addValidators(...Object.values(options.validators));
                }

            }

            if (options.placeholder) {
                el.placeholder = andy.Language.get(options.placeholder);
            }

            if (options.type) {
                el.type = options.type;
            }

            if (options.step) {
                el.step = options.step;
            }

            if (options.min) {
                el.min = options.min;
            }

            if (options.max) {
                el.max = options.max;
            }

            if (options.maxLength) {
                el.maxLength = options.maxLength;
            }

            if (options.value != null) {
                el.value = options.value;
            }

            if (options.customClass != null) {
                el.classList.add(options.customClass);
            }

            if (options.list != null) {
                el.setAttribute('list', options.list);
            }

            if (options.id != null) {
                el.setAttribute('id', options.id)
            }
        }
    }

    function changeHandler() {
        events.dispatchEvent('change', _public);
    }

    function focusHandler() {
        if (!touched) {
            touched = true;
        }
        events.dispatchEvent('focus', _public);
    }

    function blurHandler() {
        if (touched) {
            validate();
        }
        events.dispatchEvent('blur', _public);
    }

    function validate() {
        let valid = true;
        for (let i = 0; i < validators.length; i++) {
            if (!validators[i](el.value)) valid = false;
        }

        if (valid) {
            el.classList.remove('not-valid');
        } else {
            el.classList.add('not-valid');
        }

        return valid;
    }

    function addValidators() {
        [...arguments].forEach(function (arg) {
            validators.push(arg);
        });
    };

    function reset() {
        el.value = '';
        el.classList.remove('not-valid');
        touched = false;
    }

    function lock() {
        el.setAttribute('disabled', true);
    }

    function unlock() {
        el.removeAttribute('disabled');
    }

    constructor();

    const _public = {
        get value(){
            return el.value; 
        },
        get element(){
            return el;
        },
        addValidators: addValidators,
        validate: validate,
        reset,
        getElement: function () {
            return el;
        },
        getValue: function () {
            if (el.type == 'number') {
                return parseFloat(el.value);
            }
            return el.value;
        },
        returnValue: function () { // Deprecated
            return el.value;
        },
        setValue: function (value) {
            el.value = value;
        },
        lock,
        unlock,
        bind: function () { console.info('Not implemented yet: input.bind()'); },
        on: events.addEventListener
    }

    andy.UI._instances.push(_public);
    return _public;
}

/***/ }),

/***/ "./js/ui/andy.ui.label.js":
/*!********************************!*\
  !*** ./js/ui/andy.ui.label.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(value, options) {

    const events = new andy.EventManager();

    let defaultOptions = {
        isNotCode: false,
        customClass: null,
        originalValue: value,
        clickable: false
    };

    let el = new DIV('andy-ui-label');
    let bindedDataset = null;
    let bindedItem = null;
    let bindedShowField = null;

    if (typeof options == 'object') {
        options = {...defaultOptions, ...options };
    } else {
        defaultOptions.isNotCode = options;
        options = defaultOptions;
    }

    if (options.customClass) {
        el.classList.add(options.customClass);
    }

    if (options.style) {
        Object.keys(options.style).forEach(function(key) {
            el.style[key] = options.style[key];
        });
    }

    if (options.clickable) {
        el.addEventListener('click', (e) => events.dispatchEvent('click', e));
        el.classList.add('link')
    }

    function setValue(v) {
        value = v;
        if (bindedDataset) {
            if (bindedDataset.data[bindedItem]) {
                el.innerHTML = bindedDataset.data[bindedItem][bindedShowField];
            }
        } else {
            if (options.isNotCode) {
                el.innerHTML = value;
            } else {
                el.innerHTML = andy.Language.get(value);
                el.setAttribute('data-label', value);
            }
        }
    }

    function getValue() {
        return value;
    }


    function reset() {
        setValue(options.originalValue);
    }

    function bind(_dataset, item, showField) {
        // Bint to a dataset
        bindedDataset = _dataset;
        bindedItem = item;
        bindedShowField = showField;

        _dataset.on('fetch', function({ dataset }) {
            el.innerHTML = dataset[item][showField];
        });

        _dataset.on('remove', function({ document }) {
            if (document['_id'] == item) {
                el.innerHTML = 'null';
            }
        });

        _dataset.on('save', function({ document }) {
            if (document['_id'] == item) {
                el.innerHTML = document[showField];
            }
        });

        if (bindedDataset.data[bindedItem]) {
            el.innerHTML = bindedDataset.data[bindedItem][bindedShowField];
        }
    }

    setValue(value);

    let public = {
        get element() {
            return el;
        },
        getElement: function() {
            return el;
        },
        getValue,
        setValue,
        set value(v) {
            setValue(v);
        },
        get value() {
            return getValue();
        },
        reset,
        bind
    }

    andy.UI._instances.push(public);
    return public;

}

/***/ }),

/***/ "./js/ui/andy.ui.list.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.list.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (data, template, options) {

    const events = new andy.EventManager();

    const props = {
        valueProcess: null,
        placeholder: 'no_data_to_show',
       ...options
    }

    let wrapper = new DIV('andy-ui-list');

    let el = new UL('');

    wrapper.append(el);

    let likeForm = false;
    let items = [];
    let dragElm, dragSourceId, dragTargetId;
    let cDataset;
    let parentField, orderField, levelField;

    if (!!options) {
        if (!!options.parentingOptions) {
            parentField = !!options.parentingOptions.parentField ? options.parentingOptions.parentField : 'parent';
            orderField = !!options.parentingOptions.orderField ? options.parentingOptions.orderField : 'order';
            levelField = !!options.parentingOptions.levelField ? options.parentingOptions.levelField : 'level';
        }
    }

    if (props.placeholder) {
        const placeholder = new andy.UI.Label(props.placeholder, { customClass: 'placeholder' });
        const li = new LI('placeholder');

        li.append(placeholder.getElement());
        el.append(li);
    }

    function addItem(item) {

        let it = new LI('');
        let id = items.length;
        //it.style.order = id;
        let eItem = {
            item: item,
            el: it
        };

        if (!!template) {
            it.append(template(item, eItem));
        } else {
            it.appendChild(new andy.UI.Label(item).getElement());
        }

        items.push(eItem);
        el.append(it);

        if (!!options) {
            if (!!options.removable) {
                it.append(new andy.UI.Button({
                    icon: 'mdi-close'
                }, () => {
                    removeItem(id, true);
                }).getElement())
            }
            if (!!options.draggable) {
                draggable(id);
            }
            if (!!options.form) {
                likeForm = true;
            }
        }
    }

    function addItemToParent(item, parent, collection, action) {
        let it = new LI('');
        let id = items.length;
        let eItem = {
            item: item,
            el: it
        };

        if (!!template) {
            it.append(template(item, eItem));
        } else {
            it.appendChild(new andy.UI.Label(item).getElement());
        }

        items.push(eItem);
        if (parent !== null) {
            let listItems = Array.from(el.childNodes);
            for (let i = 0; i < listItems.length; i++) {
                let cItem = collection.find((x) => {
                    return x.title === listItems[i].childNodes[0].getElementsByClassName('andy-ui-label')[0].innerText;
                });
                if (cItem._id === parent) {
                    let liItem = listItems.find((x) => {
                        return x.childNodes[0].getElementsByClassName('andy-ui-label')[0].innerText === cItem.title;
                    });
                    if (!!liItem) {
                        liItem.after(it);
                    }
                }
            }
        }
        else {
            el.append(it);
        }

        if (item.level !== 0 && action === 'fetch') {
            it.style.display = 'none';
        }


        if (!!options) {
            if (!!options.removable) {
                it.append(new andy.UI.Button({
                    icon: 'delete'
                }, () => {
                    removeItem(id);
                }).getElement())
            }
            if (!!options.draggable) {
                draggable(id);
            }
            if (!!options.form) {
                likeForm = true;
            }
            if (!!options.parentingOptions) {
                if (!!options.parentingOptions.collapsible) {
                    collapsible(id, collection, item);
                }
            }
        }
    }


    function isbefore(a, b) {
        if (a.parentNode == b.parentNode) {
            for (var cur = a; cur; cur = cur.previousSibling) {
                if (cur === b) {
                    return true;
                }
            }
        }
        return false;
    }

    function updateItem(id, value) {
        let item = items[id];
        item.el.innerHTML = '';
        if (template) {
            item.el.append(template(value, item));
        } else {
            item.el.appendChild(new andy.UI.Label(value).getElement());
        }
    }

    function draggable(id) {
        let el = items[id].el;
        el.draggable = true;
        el.id = id;

        function dragstartHandler(e) {
            dragElm = e.target;
            dragSourceId = id;
            e.dataTransfer.effectAllowed = 'move';
        }

        function dragenterHandler(e) {
            e.preventDefault();
            e.stopPropagation();
            let elm = e.target;
            if (elm.nodeName == "LI") {
                if (isbefore(dragElm, elm)) {
                    elm.parentNode.insertBefore(dragElm, elm);
                    swapItems(dragElm.id, id);
                }
                else {
                    elm.parentNode.insertBefore(dragElm, elm.nextSibling);
                    swapItems(dragElm.id, id);
                }
            }
        }


        function dragendHandler(e) {

            if (!!options.parentingOptions) {
                let item, previousItem, previousItemID;
                let count = 0;
                let itemID = e.srcElement.id;
                let allPages = items;
                const htmlList = e.target.closest('.andy-ui-list').childNodes;

                for (let page in allPages) {
                    if (allPages.hasOwnProperty(page) && allPages[page].item.title === e.srcElement.childNodes[0].childNodes[1].innerText) {
                        item = allPages[page];
                    }
                }

                Array.from(htmlList).some((uiListItem, index) => {
                    if (uiListItem.id === itemID && Array.from(htmlList)[index - 1] !== undefined) {
                        const pvItem = Array.from(htmlList)[index - 1].childNodes[0].childNodes[1].innerText;
                        previousItem = allPages.find((x) => {
                            return x.item.title === pvItem;
                        });
                        previousItemID = index - 1;
                    }
                });

                if (previousItemID === undefined || previousItem.item.parent === item.item.parent || previousItem.item._id === item.item.parent || previousItem.item.level - 1 === item.item.level) {
                    const currentListOrder = getCurrentChildrenOrder(htmlList, item.item.parent);
                    currentListOrder.forEach((doc) => {
                        cDataset.save({
                            _id: doc.item._id,
                            order: count
                        });
                        count++;
                    });
                    cDataset.fetch();
                }
                else {
                    console.error('Error, invalid operation: tried to change parent page by dragging');
                    cDataset.fetch();
                }
            }

            function getCurrentChildrenOrder(list, parent) {
                const listElement = Array.from(list);
                const pagesObject = items;
                let arr = [];
                listElement.forEach((elem) => {
                    for (let doc in pagesObject) {
                        if (pagesObject.hasOwnProperty(doc) && !!pagesObject[doc]) {
                            if (!!parent) {
                                if (elem.childNodes[0].childNodes[1].innerText === pagesObject[doc].item.title && pagesObject[doc].item.parent === parent) {
                                    arr.push(pagesObject[doc]);
                                }
                            }
                            else {
                                if (elem.childNodes[0].childNodes[1].innerText === pagesObject[doc].item.title) {
                                    arr.push(pagesObject[doc]);
                                }
                            }
                        }
                    }
                });
                return arr;
            }
        }

        el.addEventListener('dragstart', dragstartHandler);
        el.addEventListener('dragenter', dragenterHandler);
        el.addEventListener('dragend', dragendHandler);
    }

    function collapsible(id, collection, item) {
        let el = items[id].el;
        el.collapsible = true;
        el.id = id;
        el.style.cursor = 'pointer';
        const cItem = collection.find((x) => { return x._id === item._id });
        el.className = cItem._id;

        function clickHandler(e) {
            e.stopPropagation();
            const _cid = e.target.closest('li').className;
            const listElement = e.target.closest('.andy-ui-list').childNodes[0].childNodes;
            // console.log('listElement', listElement);
            // console.log('_cid', _cid);
            let startIndex;
            for (let i = 0; i < listElement.length; i++) {
                if (listElement[i].className == _cid) {
                    startIndex = i;
                }
            }

            const clickedItem = collection.find((x) => { return x._id === item._id });
            let process;
            if (!!listElement[startIndex + 1]) {
                if (listElement[startIndex + 1].style.display !== 'none') {
                    process = 'hide';
                } else {
                    process = 'show';
                }
            }

            for (let i = startIndex + 1; i < listElement.length; i++) {
                const cItem = collection.find((x) => { return x._id === listElement[i].className });
                if (cItem.level > clickedItem.level) {
                    if (process === 'hide') {
                        listElement[i].style.display = 'none';
                    }
                    else if (process === 'show' && cItem.level === clickedItem.level + 1) {
                        listElement[i].style.display = 'block';
                    }
                }
                else {
                    i += 999;
                }
            }
        }

        el.addEventListener('click', clickHandler);
    }

    function swapItems(a, b) {
        let temp = items[a];
        items[a] = items[b];
        items[b] = temp;
    }

    function removeItem(id, removeEvent = false) {
        let itm = items[id];
        let original = { ...itm };
        itm.item = null;
        itm.el.remove();
        if (removeEvent) {
            events.dispatchEvent('itemRemoved', original);
        }
    }

    function addItems(items) {
        if (!!options) {
            if (!!options.parentingOptions && !!options.parentingOptions.groupByParent) {

                let itemsByLevel = items.sort((a, b) => {
                    return parseInt(a[levelField]) - parseInt(b[levelField]);
                });

                itemsByLevel = itemsByLevel.sort((a, b) => {
                    if (parseInt(a[levelField]) > parseInt(b[levelField]) || parseInt(a[levelField]) < parseInt(b[levelField])) {
                        return;
                    }
                    if (a[levelField] === b[levelField] && a[levelField] > 0) {
                        return (parseInt(b[orderField]) - parseInt(a[orderField]));
                    }
                    return (parseInt(a[orderField]) - parseInt(b[orderField]));
                });

                for (let i = 0; i < itemsByLevel.length; i++) {
                    if (itemsByLevel[i].level >= 0) {
                        addItemToParent(itemsByLevel[i], itemsByLevel[i][parentField], items, 'fetch');
                    }
                }
            }
            else {
                for (let i = 0; i < items.length; i++) {
                    addItem(items[i]);
                }
            }
        }
        else {
            for (let i = 0; i < items.length; i++) {
                addItem(items[i]);
            }
        }
    }

    function clear() {
        for (let i = 0; i < items.length; i++) {
            if (!!items[i].item) removeItem(i);
        }
        items = [];
    }

    if (!!data) {
        addItems(data);
    }

    function findIn(field, value) {
        for (let i = 0; i < items.length; i++) {
            let item = items[i].item;
            if (item) {
                if (item[field]) {
                    if (item[field] == value) {
                        return i;
                    }
                }
            }
        }
        return undefined;
    }

    function bind(_dataset) {
        // Bind to a dataset
        cDataset = _dataset;

        if(Object.values(_dataset.data).length > 0){
			addItems(Object.values(_dataset.data));
		}

        _dataset.on('fetch', function ({ dataset }) {
            clear();
            addItems(Object.values(dataset));
        });

        _dataset.on('remove', function ({ document }) {
            let found = findIn('_id', document._id);
            if (found !== undefined) {
                removeItem(found);
                if (!!options.parentingOptions) {
                    if (!!options.parentingOptions.groupByParent) {
                        _dataset.fetch();
                    }
                }
            }
        });

        _dataset.on('save', function ({ document }) {
            let found = findIn('_id', document._id);
            if (found !== undefined) {
                updateItem(found, document);
                if (!!options.parentingOptions) {
                    if (!!options.parentingOptions.groupByParent) {
                        _dataset.fetch();
                    }
                }
            } else {
                if (!!options.parentingOptions) {
                    if (!!options.parentingOptions.groupByParent) {
                        addItemToParent(document, document[parentField], Object.values(_dataset.data), 'create');
                    }
                }
                else {
                    addItem(document);
                }
            }
        });

    }

    function search(value, key, normalize = false) {

        function normalizeStr(val) {
            if (normalize) {
                return val.toLowerCase().trim();
            }
            return val;
        }

        if (value.trim()) {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (item.item[key]) {
                    if (normalizeStr(item.item[key]).includes(normalizeStr(value))) {
                        item.el.style.display = 'flex';
                    } else {
                        item.el.style.display = 'none';
                    }
                }
            }
        } else {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                item.el.style.display = 'flex';
            }
        }
    }

    let public = {
        get props(){
            return props;
        },
        getElement: function () {
            return wrapper;
        },
        add: function (v, bulk) {
            if (!bulk) {
                addItem(v);
            } else {
                v.forEach(function (element) {
                    addItem(element);
                });
            }
        },
        updateItem,
        edit: function (id, item) {
            items[id].item = item;
        },
        findIn: findIn,
        remove: removeItem,
        setValue: function (v) {
            clear();
            addItems(v);
        },
        getValue: function (process) {
            if(!process){
                if(props.valueProcess){
                    process = props.valueProcess;
                }
            }
            let values = null;
            if (likeForm) {
                values = {};
                Object.keys(items).forEach(function (key) {
                    let field = items[key];
                    if (field.item && field.item.getValue) {
                        values[key] = field.item.getValue();
                    }
                });
                return Object.values(values);
            } else {
                values = [];
                items.forEach(function (it) {
                    if (!!it.item) {
                        if (!!process) {
                            values.push(process(it.item));
                        } else {
                            values.push(it.item);
                        }
                    }
                });
                return values;
            }
        },
        setTemplate: function (t) {
            template = t;
        },
        reset: function () {
            clear();
        },
        clear,
        on: events.addEventListener,
        search,
        bind
    }


    andy.UI._instances.push(public);
    return public;
}


/***/ }),

/***/ "./js/ui/andy.ui.menu.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.menu.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) {

    let items = {};

    function renderItem({ label, icon }) {
        let element = new DIV('');
        if (icon) {
            let iconEl = new andy.UI.Icon(icon);
            element.append(iconEl.getElement());
        }

        if (label) {
            let labelEl = new andy.UI.Label(label);
            element.append(labelEl.getElement());
        }

        return element;
    }

    let defaultOptions = {
        orientation: 'vertical',
        renderItem,
        route: null
    }

    options = { ...defaultOptions, ...options };

    let wrapper = new DIV('andy-ui-menu');

    if (options.orientation) {
        wrapper.classList.add(options.orientation);
    }

    if (options.style) {
        Object.keys(options.style).forEach(function (key) {
            wrapper.style[key] = options.style[key];
        });
    }

    function deselectAll(exceptionKey = null) {
        Object.keys(items).forEach(function (itemKey) {
            if (exceptionKey) {
                if (itemKey != exceptionKey) {
                    items[itemKey].deselect();
                }
            } else {
                items[itemKey].deselect();
            }
        });
    }

    function remove(code) {
        items[code].remove();
        delete items[code];
    }



    function clear() {
        Object.keys(items).forEach(key => {
            remove(key);
        });
    }

    function add({ code, label, icon, callback, route }) {

        if (!code) {
            code = andy.uid.generate();
        }

        let events = new andy.EventManager();

        let element = options.renderItem({ label, icon, code });
        element.classList.add('item');

        function select(conf) {
            let defaults = {
                stopProp: false
            }

            conf = { ...defaults, ...conf }


            deselectAll(code);
            element.classList.add('selected');


            if (callback) callback();
            if (!conf.stopProp) {
                events.dispatchEvent('select', null);
            }
        }

        function deselect(conf) {

            let defaults = {
                stopProp: false
            }

            conf = { ...defaults, ...conf }

            element.classList.remove('selected');
            if (!conf.stopProp) {
                events.dispatchEvent('deselect', null);
            }
        }

        function shrink() {
            let defaults = {
                stopProp: false
            }

            conf = { ...defaults, ...conf }

            element.classList.add('shrink');
            if (!conf.stopProp) {
                events.dispatchEvent('shrink', null);
            }
        }

        function unshrink() {
            let defaults = {
                stopProp: false
            }

            conf = { ...defaults, ...conf }

            element.classList.remove('shrink');

            if (!conf.stopProp) {
                events.dispatchEvent('shrink', null);
            }
        }

        function connect(component, paramA, paramB) {
            component.on(paramA, () => public[paramB]({ stopProp: true }));
            events.addEventListener(paramB, () => component[paramA]({ stopProp: true }));
        }

        function remove() {
            element.remove();
            delete items[code];
        }

        let public = {
            code,
            shrink,
            unshrink,
            select,
            deselect,
            remove,
            element,
            connect,
            on: events.addEventListener
        }

        element.addEventListener('click', function (e) {
            select();
            if (callback) {
                //callback(public, e);
            }
        });

        items[code] = public;
        wrapper.append(element);

        return public;
    }

    function selectFirst() {
        let keys = Object.keys(items);
        if (keys.length > 0) {
            items[keys[0]].select();
        }
    }

    function select(code) {
        if (items[code]) {
            items[code].select();
        }
    }

    let public = {
        get items() {
            return items;
        },
        getElement: function () {
            return wrapper;
        },
        clear,
        selectFirst,
        select,
        add,
        remove
    }

    andy.UI._instances.push(public);
    return public;

}

/***/ }),

/***/ "./js/ui/andy.ui.radiobutton.js":
/*!**************************************!*\
  !*** ./js/ui/andy.ui.radiobutton.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (value) {
    value = (typeof value !== 'undefined') ? value : false;

    let scope = this;
    let el = new DIV('andy-ui-radiobutton');
    let pin = new DIV('pin');

    el.append(pin);
    el.addEventListener('click', toggle);

    function toggle() {
        if (value) {
            value = false;
        } else {
            value = true;
        }
        toggleClass();
        el.value = value;
    }

    function toggleClass() {
        if (!value) {
            el.classList.remove('selected');
        } else {
            el.classList.add('selected');
        }
    }

    let public = {
        value: value,
        reset: function () {
            value = false;
            el.value = false;
            toggleClass();
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        returnValue: function () { // Deprecated
            return value;
        },
        setValue: function (v) {
            value = v;
            toggleClass();
        },
        toggle: toggle,
        bind: function () { console.info('Not implemented yet: checkbox.bind()'); },
        on: function () { console.info('Not implemented yet: checkbox.on()'); }
    }

    el.setValue = public.setValue; //added for back compatibility

    toggleClass();

    andy.UI._instances.push(public);
    return public;

}

/***/ }),

/***/ "./js/ui/andy.ui.retrosearchbox.js":
/*!*****************************************!*\
  !*** ./js/ui/andy.ui.retrosearchbox.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (component, options) {

    let events = new andy.EventManager();

    let results = [];

    let defaultOptions = {
        key: 'tags',
        minChars: 2,
        normalize: true,
        placeholder: 'search'
    }

    options = { ...defaultOptions, ...options };

    let el = new INPUT('andy-ui-searchbox');
    el.placeholder = andy.Language.get(options.placeholder);


    function search(value) {
        results = [];
        if (component.search) {
            let res = component.search(value, options.key, options.normalize);
            if (typeof res == 'array') {
                results = [...results, ...res];
            }
        }
        events.dispatchEvent('search', results);
    }

    el.addEventListener('keyup', function () {
        search(this.value);
    });

    let public = {
        on: events.addEventListener,
        reset: function () {
            el.value = '';
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return el.value;
        },
        setValue: function (val) {
            el.value = val;
            search(val);
        }
    }

    andy.UI._instances.push(public);
    return public;
}


/***/ }),

/***/ "./js/ui/andy.ui.richtexteditor.js":
/*!*****************************************!*\
  !*** ./js/ui/andy.ui.richtexteditor.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

let dismissCallback;
let richtextModal = new DIV('andy-ui-richtext-modal');
let richtextModalWrapper = new DIV('andy-ui-richtext-wrapper');
let wrapper = new DIV('andy-ui-richtext');
let textarea = new TEXTAREA('');
textarea.id = 'richtextElement';
let textEditorForm = null;
let tinymceInstance;

function createForm() {
    if (!textEditorForm) {

        wrapper.append(textarea);

        let textEditor = {
            getElement: function () {
                return wrapper;
            }
        }

        textEditorForm = new andy.UI.Form('text_editor', {
            editor: { label: '', item: textEditor }
        }, {
                cancel: new andy.UI.Button({ label: 'cancel', icon: 'cancel' }, function () {
                    richtextModal.hide();
                }),
                save: new andy.UI.Button({ label: 'save', icon: 'save' }, function () {
                    richtextModal.hide();
                    if (dismissCallback) dismissCallback(); //save value
                })
            });

        richtextModal.append(textEditorForm.getElement());


        richtextModal.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        richtextModal.show = function () {
            richtextModalWrapper.classList.add('show');
            this.classList.add('show');
        }

        richtextModal.hide = function () {
            this.classList.remove('show');
            richtextModalWrapper.classList.remove('show');

        }

        richtextModalWrapper.append(richtextModal);
        document.body.appendChild(richtextModalWrapper);

        initTinyMce();
    }

}

function initTinyMce() {
    try {
        tinymceInstance = tinyMCE.init({
            target: textarea,
            branding: false,
            force_br_newlines: false,
            force_p_newlines: false,
            forced_root_block: '',
            plugins: 'code',
            toolbar: 'undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
        });
    } catch (error) {
        console.log('TinyMCE not loaded.')
    }
}

function setTinyMCEValue(val) {
    if (!val) {
        tinymce.get('richtextElement').setContent('');
    } else {
        tinymce.get('richtextElement').setContent(val);
    };

};

function getTinyMCEValue() {
    return tinymce.get('richtextElement').getContent();
}
//  andy.UI.RichTextEditor
module.exports = function (options) {


    createForm();
    let value;

    let el = new DIV('andy-ui-richtext-preview');

    el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dismissCallback = function () {
            setValue(getTinyMCEValue());
        }

        setTinyMCEValue(value);
        richtextModal.show();
    });

    function setValue(val) {
        value = val;
        el.innerHTML = val;
    };

    let public = {
        reset: function () {
            setValue('');
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: setValue
        // bind: function() { console.info('Not implemented yet: textarea.bind()'); },
        // on: function() { console.info('Not implemented yet: textarea.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}



/***/ }),

/***/ "./js/ui/andy.ui.searchbox.js":
/*!************************************!*\
  !*** ./js/ui/andy.ui.searchbox.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (datasetFilter, options) {

    const events = new andy.EventManager();

    const props = {
        key: 'tags',
        minChars: 2,
        normalize: true,
        placeholder: 'search',
        ...options
    }

    let el = new INPUT('andy-ui-searchbox');
    el.placeholder = andy.Language.get(props.placeholder);

    let isFilterActive = false;

    function search(value) {
        if (datasetFilter.search) {
            datasetFilter.search(value, props.key, props.normalize);
        }

        events.dispatchEvent('search', { ...datasetFilter.data });
    }

    el.addEventListener('keyup', function () {
        if (this.value.length >= props.minChars) {
            isFilterActive = true;
            search(this.value);
        }
        else if (isFilterActive){
            datasetFilter.removeFilter('search');
            isFilterActive = false;
        }
    });

    let public = {
        on: events.addEventListener,
        reset: function () {
            el.value = '';
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return el.value;
        },
        setValue: function (val) {
            el.value = val;
            search(val);
        },
        bind: function(_datasetFilter) {
            datasetFilter = _datasetFilter;
        }
    }

    andy.UI._instances.push(public);
    return public;
}



/***/ }),

/***/ "./js/ui/andy.ui.select.js":
/*!*********************************!*\
  !*** ./js/ui/andy.ui.select.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(options, process) {

    let items = {};
    let events = new andy.EventManager();

    let el = new SELECT('andy-ui-select');

    function constructor() {

    }

    function addOption(code, label, selected) {
        let option;
        if (!items[code]) {
            option = new OPTION('', andy.Language.get(label), code);
            el.append(option);
            items[code] = option;
        } else {
            option = items[code];
            option.innerHTML = andy.Language.get(label);
        }
        option.setAttribute('data-label', label);
        if (!!selected) {
            option.selected = true;
        }
    }

    el.addEventListener("change", () => {
        events.dispatchEvent('change', public);
    })

    function addOptions(ops) {
        if (Array.isArray(ops)) {
            ops.forEach(function(op) {
                if (process) {
                    process(op, addOption);
                } else {
                    if (typeof op == 'object') {
                        addOption(...op);
                    } else {
                        addOption(op, op);
                    }
                };
            })

        } else {

            Object.keys(ops).forEach(function(key) {
                let option = ops[key];
                if (process) {
                    process(option, addOption);
                } else {
                    addOption(...option);
                };
            });
        }
    }


    function removeOption(code) {
        if (!!items[code]) {
            items[code].remove();
            delete items[code];
        }
    }

    function clear() {
        Object.keys(items).forEach(removeOption);
    }

    if (!!options) {
        addOptions(options);
    }

    function bind(_dataset) {
        // Bind to a dataset

        if (Object.values(_dataset.data).length > 0) {
            addOptions(Object.values(_dataset.data));
        }

        _dataset.on('fetch', function({ dataset }) {
            addOptions(dataset);
        });

        _dataset.on('remove', function({ document }) {
            removeOption(document._id);
        });

        _dataset.on('save', function({ document }) {
            if (items[document._id]) {
                removeOption(document._id);
            }
            addOptions([document]);
        });
    }

    constructor();

    let public = {
        get element() {
            return el;
        },
        getElement: function() {
            return el;
        },
        getValue: function() {
            return el.value;
        },
        setValue: function(v) {
            el.value = v;
        },
        add: function(op) {
            if (!!process) {
                process(op, addOption);
            } else {
                addOption(...op);
            };
        },
        addBulk: addOptions,
        setProcess: function(t) {
            process = t;
        },
        remove: removeOption,
        clear,
        bind,
        on: events.addEventListener
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.slidebar.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.slidebar.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (value) {

    value = (!value) ? 0 : value;

    let scope = this;
    let el = new DIV('andy-ui-slidebar');
    let pin = new DIV('pin');
    let tooltip = new DIV('pin-tooltip');
    let setedValue = false;
    let events = {};
    tooltip.innerHTML = "0";
    pin.appendChild(tooltip);
    el.append(pin);

    let isDown = false,
        start = 0,
        current = 0,
        distance = 0,
        track;

    function mouseDownHandler(e) {
        track = el.getBoundingClientRect();
        if (setedValue) {
            current = value * track.width;
            setedValue = false;
        } else {
            current = trackBound(current + distance);
        }
        start = e.clientX;
        distance = 0;
        isDown = true;
    }

    function mouseUpHandler(e) {
        if (isDown) {
            updateValue(trackBound(current + distance));
            if (events.endChange) {
                events.endChange(public)
            }
        }
        isDown = false;
    }

    function mouseMoveHandler(e) {
        if (isDown) {
            distance = e.clientX - start;
            pin.style.left = trackBound(current + distance) + 'px';
            updateValue(trackBound(current + distance));
        }
    }

    function trackBound(dist) {
        if (dist < 0) return 0;
        if (dist > track.width) return track.width;
        return dist;
    }

    function updateValue(pos) {
        value = pos / track.width;
        tooltip.innerHTML = Math.round(value * 100);
    }

    function updatePin(v) {

        pin.style.left = v + '%';
        tooltip.innerHTML = Math.round(v);


    }

    pin.addEventListener('mousedown', mouseDownHandler);
    document.body.addEventListener('mouseup', mouseUpHandler);
    document.body.addEventListener('mousemove', mouseMoveHandler);

    let public = {
        value: value,
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: function (v) {
            value = v;
            setedValue = true;
            updatePin(v * 100);
        },
        bind: function () {
            console.info('Not implemented yet: checkbox.bind()');
        },
        on: function (event, cb) {
            events[event] = cb;
        }
    }

    andy.UI._instances.push(public);
    return public;

}

/***/ }),

/***/ "./js/ui/andy.ui.switch.js":
/*!*********************************!*\
  !*** ./js/ui/andy.ui.switch.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(value) {

    let events = new andy.EventManager();

    value = (typeof value !== 'undefined') ? value : false;

    let scope = this;
    let el = new DIV('andy-ui-switch');
    let pin = new DIV('pin');

    el.append(pin);
    el.addEventListener('click', toggle);

    function toggle() {
        if (value) {
            value = false;
        } else {
            value = true;
        }
        toggleClass();
        el.value = value;
        events.dispatchEvent('change', value);
    }

    function toggleClass() {
        if (!value) {
            el.classList.remove('selected');
        } else {
            el.classList.add('selected');
        }
    }

    function lock() {
        el.classList.add('locked');
    }

    function unlock() {
        el.classList.remove('locked');
    }

    let public = {
        value: value,
        reset: function() {
            value = false;
            el.value = false;
            toggleClass();
        },
        get element() {
            return el;
        },
        getElement: function() {
            return el;
        },
        getValue: function() {
            return value;
        },
        returnValue: function() { // Deprecated
            return value;
        },
        setValue: function(v) {
            value = v;
            toggleClass();
        },
        toggle: toggle,
        lock,
        unlock,
        bind: function() { console.info('Not implemented yet: switch.bind()'); },
        on: events.addEventListener
    }

    el.setValue = public.setValue; //added for back compatibility

    toggleClass();

    andy.UI._instances.push(public);
    return public;
}

// var Toggle = andy.UI.Switch; // Added for back compatibility

/***/ }),

/***/ "./js/ui/andy.ui.tabs.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.tabs.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (tabs, options) {
    let items = {};
    let value = {};
    let el = new DIV('andy-ui-tabs');
    let menuWrapper = new DIV('menu');
    let tabsWrapper = new DIV('tabs');
    let buttonWrapper = new DIV('buttons');
    let viewsWrapper = new DIV('views');

    menuWrapper.append(tabsWrapper, buttonWrapper);
    el.append(menuWrapper, viewsWrapper);

    let defaults = {
        multiview: true,
        view: null
    }

    options = Object.assign({}, defaults, options);

    if (!options.multiview && options.view) {
        viewsWrapper.append(options.view);
        options.view.classList.add('selected');
    }

    if (tabs) {
        Object.keys(tabs).map(function (key) {
            add(key, tabs[key].label, tabs[key].element, tabs[key].callback, tabs[key].fixed);
        });
        selectFirst();
    }

    function selectFirst() {
        if (items[Object.keys(items)[0]]) {
            items[Object.keys(items)[0]].select();
        }
    }

    function unselectItems(code) {
        Object.keys(items).map(function (item) {
            if (code !== item) items[item].unselect();
        })
    }

    function clear() {
        Object.keys(items).map(function (item) {
            items[item].remove();
        })
    }

    function createMenuElement(code, label, callback, fixed, removeCB) {
        let itemEl = new DIV((fixed) ? fixed : '');
        itemEl.append(new andy.UI.Label(label).getElement());
        if (options.close) {
            itemEl.append(new andy.UI.Button({
                label: '',
                icon: 'mdi-close'
            }, () => {
                if (removeCB) {
                    removeCB();
                }
            }).getElement());
        }
        itemEl.select = function () {
            unselectItems(code);
            this.classList.add('selected');
            if (callback) callback();
        }

        itemEl.unselect = function () {
            this.classList.remove('selected');
        }

        itemEl.addEventListener('click', function (e) {
            this.select();
        })


        return itemEl;
    }

    function createViewElement(code, element) {
        let itemEl = new DIV('');

        if (element) {
            itemEl.append(element);
        }


        itemEl.select = function () {
            this.classList.add('selected');
        }

        itemEl.unselect = function () {
            this.classList.remove('selected');
        }

        return itemEl;
    }

    function add(code, label, element = null, callback, fixed = null, removeCB) {
        let viewEl = null;
        let menuEl = createMenuElement(code, label, function () {
            if (callback) callback();
            if (viewEl) viewEl.select();
        }, fixed, removeCB);

        tabsWrapper.append(menuEl);

        if (options.multiview) {
            viewEl = createViewElement(element);
            viewsWrapper.append(viewEl);
        }

        let item = {
            select: function () {
                menuEl.select();
                if (viewEl) viewEl.select();
            },
            unselect: function () {
                menuEl.unselect();
                if (viewEl) viewEl.unselect();
            },
            remove: function () {
                menuEl.remove();
                if (viewEl) viewEl.remove();
                if (items[code]) delete items[code]
            }
        }

        items[code] = item;
        item.select();
    }

    function addButton(label, callback, args) {
        // let buttonEl = new DIV('');

        // buttonEl.append(new andy.UI.Label(label).getElement());

        // buttonEl.addEventListener('click', function () {
        //     if (callback) callback(args);
        // })

        const button = new andy.UI.Button({icon: 'mdi-plus'}, ()=>{
            if (callback) callback(args);
        })

        buttonWrapper.append(button.element);
    }

    let public = {
        items: tabs,
        tabs: items,
        add: add,
        addButton: addButton,
        clear: clear,
        selectFirst: selectFirst,
        getElement: function () {
            return el;
        },
        getValue: function () {
            return value;
        },
        setValue: function (values) {
            value = values;
            return value;
        }
        // bind: function() { console.info('Not implemented yet: form.bind()'); },
        // on: function() { console.info('Not implemented yet: form.on()'); }
    }

    andy.UI._instances.push(public);
    return public;

}

/***/ }),

/***/ "./js/ui/andy.ui.tags.js":
/*!*******************************!*\
  !*** ./js/ui/andy.ui.tags.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(tagStr) {

    let tags = {};

    let el = new DIV('andy-ui-tags');
    let inputEl = new DIV('input');
    inputEl.setAttribute('contenteditable', 'true');
    el.append(inputEl);

    function blurHandler() {
        addTag(this.innerHTML);
        this.innerHTML = '';
    }

    inputEl.addEventListener('blur', blurHandler);

    function spaceKeyHandler(e) {
        var key = e.which;
        if (key == 32) {
            addTag(this.innerHTML);
            this.innerHTML = '';
        }
    }

    inputEl.addEventListener('keypress', spaceKeyHandler);

    function addTag(value) {
        if (value.trim() !== '' && value.trim() !== '&nbsp;') {
            let tag = new DIV('tag');
            let label = new andy.UI.Label(value, true);
            let remove = new andy.UI.Icon('mdi-close');
            tag.append(label.getElement(), remove.getElement());

            function removeHandler() {
                removeTag(value);
            }

            remove.getElement().addEventListener('click', removeHandler);
            if (!tags[value]) {
                el.append(tag);
                tags[value] = tag;
            }
        }
    }

    function parseTagStr(tagStr) {
        let tagArr = tagStr.split(' ');
        tagArr.forEach(function(element) {
            addTag(element);
        });
    }

    function removeTag(value) {
        tags[value].remove();
        delete tags[value];
    }

    function reset() {
        Object.keys(tags).forEach(function(value) {
            removeTag(value);
        });
    }

    if (!!tagStr) {
        parseTagStr(tagStr);
    }

    function lock() {
        inputEl.setAttribute('disabled', true);
    }

    function unlock() {
        inputEl.removeAttribute('disabled');
    }

    let public = {
        get element() {
            return el;
        },
        getElement: function() {
            return el;
        },
        getValue: function() {
            return Object.keys(tags).join(' ');
        },
        setValue: function(v) {
            reset();
            parseTagStr(v);
        },
        reset: reset,
        remove: removeTag,
        add: addTag,
        lock,
        unlock,
        bind: function() { console.info('Not implemented yet: tags.bind()'); },
        on: function() { console.info('Not implemented yet: tags.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.textarea.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.textarea.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (options) {

    let el = new TEXTAREA('andy-ui-textarea');

    let validators = [];
    let touched = false;

    function focusHandler() {
        touched = true;
    }

    function blurHandler() {

        if (touched) {
            if (validate()) {
                el.classList.remove('not-valid');
            } else {
                el.classList.add('not-valid');
            }
        }
        touched = false;
    }

    el.addEventListener('focus', focusHandler);
    el.addEventListener('blur', blurHandler);

    function validate() {

        for (let i = 0; i < validators.length; i++) {
            if (!validators[i](el.value)) return false
        }
        return true;
    }

    function addValidators() {
        [...arguments].forEach(function (arg) {
            validators.push(arg);
        });
    };

    if (!!options) {
        if (options.validators) {
            if (typeof options.validators === 'function') {
                addValidators(options.validators);
            } else {
                addValidators(...Object.values(options.validators));
            }
        }
        if (options.value) {
            el.value = options.value
        }
    }

    let public = {
        value: el.value,
        addValidators: addValidators,
        validate: validate,
        reset: function () {
            el.value = '';
        },
        getElement: function () {
            return el;
        },
        getValue: function () {
            return el.value;
        },
        returnValue: function () { // Deprecated
            return el.value;
        },
        setValue: function (value) {
            el.value = value;
        },
        bind: function () { console.info('Not implemented yet: textarea.bind()'); },
        on: function () { console.info('Not implemented yet: textarea.on()'); }
    }

    andy.UI._instances.push(public);
    return public;
}

/***/ }),

/***/ "./js/ui/andy.ui.treelist.js":
/*!***********************************!*\
  !*** ./js/ui/andy.ui.treelist.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (items, template) {

    let el = new DIV('andy-ui-treelist');
    let header = new DIV('header');
    let itemList = new DIV('list');
    let backButton = new andy.UI.Button({
        icon: 'arrow_back',
        label: ''
    }, function () {
        back();
    });
    let breadcrumbs = new DIV('breadcrumbs');
    let level = [];
    let breads = [];
    let listItems = [];

    header.append(backButton.getElement(), breadcrumbs);

    el.append(header, itemList);

    // backButton.hide = function() {
    //     this.classList.add('collapse');
    // }

    // backButton.show = function() {
    //     this.classList.remove('collapse');
    // }

    function back() {
        if (level.length > 1) {
            level.splice(-1, 1);
            render(level[level.length - 1]);
        }
    }

    function reset() {
        level = [];
        render(items);
    }

    function renderBreadcrumbs() {
        breadcrumbs.innerHTML = breads.slice(1, level.length).join(" > ");
    }

    function clearList() {
        for (let i = 0; i < listItems.length; i++) {
            listItems[i]._element.remove();
        }
        listItems = [];
    }

    function renderListItem(item) {
        let itemWrapper = new DIV('item');
        let itemHeader = new DIV('header');
        let itemActions = new DIV('actions');

        itemHeader.addEventListener('pointerup', function () {
            if (item.items) {
                if (item.items.length > 0) {
                    breads[level.length] = item.label;
                    render(item.items);
                }
            }
        });

        let childCount = new DIV('child-count', (item.items.length > 0) ? item.items.length : '');
        itemHeader.append(childCount);

        let label = new andy.UI.Label(item.label);

        itemHeader.append(label.getElement());

        if (template) {
            itemActions.append(template(item));
        }

        itemWrapper.append(itemHeader, itemActions);
        itemList.append(itemWrapper);
        item._element = itemWrapper;
        listItems.push(item);
        return itemWrapper;
    }

    function render(items) {

        clearList();

        if (level[level.length - 1] != items) {
            level.push(items);
        }
        renderBreadcrumbs();

        if (level.length > 1) {
            backButton.getElement().classList.remove('hide');
            // backButton.show();
        } else {
            backButton.getElement().classList.add('hide');
            // backButton.hide();
        }

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            renderListItem(item);
        }


    }

    if (items) {
        render(items);
    }

    let public = {
        getItems: function () {
            return items;
        },
        getCurrentListItems: function () {
            return listItems;
        },
        updateValue: function (i) {
            //Pedro @ 12 Jul - Temporary fix for shamir
            /* console.log('aqui', i); */
            items = i;
            // back();
        },
        getElement: function () {
            return el;
        },
        getValue: function (items, template) {

        },
        setValue: function (i, t) {
            if (t) {
                template = t;
            }
            items = i;
            render(items);
        }
    }

    andy.UI._instances.push(public);
    return public;


}

/***/ }),

/***/ "./js/ui/dropdown/dropdown.js":
/*!************************************!*\
  !*** ./js/ui/dropdown/dropdown.js ***!
  \************************************/
/*! exports provided: DropDown */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropDown", function() { return DropDown; });
/* harmony import */ var _dropdown_modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dropdown.modal */ "./js/ui/dropdown/dropdown.modal.js");


const _globalDropdownModal = new _dropdown_modal__WEBPACK_IMPORTED_MODULE_0__["DropdownModal"]();

function DropDown(p) {

    const events = new andy.EventManager();

    const props = {
        icon: undefined,
        label: undefined,
        group: true,
        customClass: '',
        left: undefined,
        right: undefined,
        bottom: undefined,
        top: undefined,
        offsetX: 0,
        offsetY: 0,
        items: {},
        newModal: false,
        modal: _globalDropdownModal,
        element: null,
        modalProps: {},
        ...p
    }


    let button, group = null;

    function constructor() {

        if (props.newModal) {
            props.modal = new _dropdown_modal__WEBPACK_IMPORTED_MODULE_0__["DropdownModal"](props.modalProps);
        }

        button = new andy.UI.Button({ icon: props.icon, label: props.label, customClass: props.customClass }, openHandler);

        if (props.group) {
            group = new andy.UI.Group(props.items, { style: { flexDirection: 'column' } });
            props.element = group.element;
        }

    }

    function openHandler(e) {
        props.modal.clear();
        events.dispatchEvent('opened');
        props.modal.append(props.element);
        props.modal.show(button.element);
    }

    constructor();

    let _public = Object.freeze({
        props,
        get element() {
            return button.element;
        },
        get button() {
            return button;
        },
        get group() {
            return group;
        },
        reset: function() {},
        getElement: function() {
            return button.getElement();
        },
        getValue: function() {
            return group.getValue();
        },
        setLabel: function(value) {
            button.label.setValue(value);
        },
        setValue: function(val) {
            group.setValue(val);
        },
        on: events.on
    });

    andy.UI._instances.push(_public);
    return _public;
};

/***/ }),

/***/ "./js/ui/dropdown/dropdown.modal.js":
/*!******************************************!*\
  !*** ./js/ui/dropdown/dropdown.modal.js ***!
  \******************************************/
/*! exports provided: DropdownModal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownModal", function() { return DropdownModal; });
function DropdownModal(p) {

    const props = {
        removeTimeout: 1000,
        matchWidth: true,
        customClass: '',
        closeOnInsideClick: true,
        closeOnOutsideClick: true,
        xDirection: 'left',
        yDirection: 'down',
        ...p
    }

    let dropdownModalWrapper, dropdownModal;
    let rTimeout = null;

    function constructor() {

        dropdownModalWrapper = new DIV('andy-ui-dropdown-wrapper');
        dropdownModal = new DIV('andy-ui-dropdown-modal');


        props.closeOnInsideClick ? dropdownModal.addEventListener('pointerup', dismissHandler, true) : null;
        props.closeOnOutsideClick ? dropdownModalWrapper.addEventListener('click', dismissHandler) : null;
    }


    function dismissHandler(e) {
        hide();
    }

    function show(related) {
        if (rTimeout) {
            clearTimeout(rTimeout);
            rTimeout = null;
        }

        appendToDocument();

        const relatedRects = related.getBoundingClientRect();
        const modalRects = dropdownModal.getBoundingClientRect();

        if (props.xDirection == 'left') {
            dropdownModal.style.left = relatedRects.left + 'px';
        } else {
            dropdownModal.style.left = (relatedRects.right - modalRects.width) + 'px';
        }

        if (props.yDirection == 'down') {
            dropdownModal.style.top = relatedRects.bottom + 'px';
        } else {
            dropdownModal.style.top = (relatedRects.top - modalRects.height) + 'px';
        }

        if (props.matchWidth)
            dropdownModal.style.width = relatedRects.width + 'px';

        dropdownModalWrapper.classList.add('show');
        dropdownModal.classList.add('show');
    }


    function hide() {
        dropdownModal.classList.remove('show');
        dropdownModalWrapper.classList.remove('show');
        rTimeout = setTimeout(remove, props.removeTimeout);
    }

    function appendToDocument() {
        document.body.appendChild(dropdownModalWrapper);
        document.body.appendChild(dropdownModal);
    }

    function remove() {
        dropdownModalWrapper.remove();
        dropdownModal.remove();
        rTimeout = null;
    }

    function clear() {
        dropdownModal.innerHTML = '';
    }

    function append() {
        dropdownModal.append(...arguments);
    }


    constructor();

    return Object.freeze({
        props,
        show,
        hide,
        clear,
        append
    })

}

/***/ }),

/***/ "./js/ui/list/list.js":
/*!****************************!*\
  !*** ./js/ui/list/list.js ***!
  \****************************/
/*! exports provided: List */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return List; });
function List(p) {

    let events = new andy.EventManager();

    const props = {
        items: {},
        array: false,
        itemTemplate: defaultItemTemplate,
        dataset: null,
        className: 'andy-ui-list',
        selectable: false,
        multi: false,
        placeholder: 'no_data_to_show',
        ...p
    }

    let items = {};

    let element, placeholder;

    function constructor() {
        placeholder = new andy.UI.Label(props.placeholder, { customClass: 'placeholder' });
        element = new DIV(props.className);

        element.append(placeholder.getElement());

        if (props.dataset) {
            bind(props.dataset);
        } else {
            setItems(props.items);
        }

    }

    function setItems(items) {

        if (Array.isArray(items)) {
            props.array = true;
            items = {...items };
        }

        Object.keys(items).forEach(key => {
            set(key, items[key]);
        });

    }

    function selectAll(except) {
        Object.keys(items).forEach(key => {
            if (key != except) {
                items[key].selected = true;
                items[key].el.classList.add('selected');
            }
        })
    }

    function deselectAll(except) {
        Object.keys(items).forEach(key => {
            if (key != except) {
                items[key].selected = false;
                items[key].el.classList.remove('selected');
            }
        })
    }

    function select(key) {
        if (items[key]) {
            items[key].selected = !items[key].selected;
        }
    }

    function createItem(key, value) {
        const iEvents = new andy.EventManager();
        let _selected = false;

        const item = {
            key,
            value,
            events: iEvents,
            set selected(v) {
                if (props.selectable) {
                    _selected = v;
                    iEvents.dispatch('selected', item);
                    events.dispatch('selected', item);
                    if (v) {
                        this.el.classList.add('selected');
                        if (!props.multi)
                            deselectAll(key);
                    }
                    else {
                        this.el.classList.remove('selected');
                    }
                }
            },
            get selected() {
                return _selected;
            }
        }

        const el = props.itemTemplate(value, key, item)

        item.el = el;

        return item;
    }


    function set(key, value) {
        const item = new createItem(key, value);

        if (items[key]) {
            items[key].el.replaceWith(item.el);
            delete items[key];
        } else {
            element.append(item.el);
        }

        items[key] = item;
    }

    function remove(key) {
        const item = items[key];
        if (item) {
            item.el.remove();
            delete items[key];
        }
    }

    function clear() {
        Object.values(items).forEach(item => {
            item.el.remove();
        });
        items = {};
    }

    function reset() {
        clear();
        setItems(props.items);
    }

    function defaultItemTemplate(item) {
        return new DIV('andy-ui-list-item', item);
    }

    function bind(_dataset) {

        const _key = _dataset.props.key;

        clear();

        if (Object.values(_dataset.data).length > 0) {
            setItems(_dataset.data);
        }

        _dataset.on('fetch', function({ dataset }) {
            clear();
            setItems(dataset);
        });

        _dataset.on('remove', function({ document }) {
            remove(document[_key]);
        });


        _dataset.on('save', function({ document }) {
            set(document[_key], document);
        });

    }

    function search() {

    }

    function getValue() {
        const output = {};

        Object.values(items).forEach(item => {
            output[item.key] = item.value;
        });

        if (props.array) {
            return Object.values({...output });
        }
        return {...output };
    }

    function getSelected() {
        const selected = {};

        Object.values(items).forEach(item => {
            if (item.selected) {
                selected[item.key] = item.value;
            }
        });

        if (props.array) {
            return Object.values({...selected});
        }

        return { ...selected }
    }

    function changeMode(mode) {
        switch(mode) {
            case 'select':
                props.selectable = true;
                props.multi = false;
                break;

            case 'multi':
                props.selectable = true;
                props.multi = true;
                break;

            default:
                props.selectable = false;
                props.multi = false;
                break;

        }
    }

    constructor();

    let _public = {
        get props() {
            return props;
        },
        getElement: function() {
            return element;
        },
        get element() {
            return element;
        },
        get value() {
            return getValue();
        },
        deselectAll,
        selectAll,
        set,
        add: set,
        setValue: setItems,
        clear,
        reset,
        remove,
        bind,
        search,
        getValue,
        getSelected,
        select,
        changeMode,
        on: events.addEventListener
    }

    andy.UI._instances.push(_public);
    return _public;
}

/***/ }),

/***/ "./js/ui/modal/modal.js":
/*!******************************!*\
  !*** ./js/ui/modal/modal.js ***!
  \******************************/
/*! exports provided: Modal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal; });
let zIncrement = 9000;
function Modal(components, p) {

    let events = new andy.EventManager();

    const props = {
        ... {
            dismissable: true,
            parent: document.body,
            customClass: '',
            removeTimeout: 150
        },
        ...p
    }

    let wrapperEl, modalEl;
    let rTimeout = null;

    function constructor() {
        wrapperEl = new DIV('andy-ui-modal ' + props.customClass);
        modalEl = new DIV('modal');

        wrapperEl.append(modalEl);
        wrapperEl.addEventListener('click', dismissHandler);


        modalEl.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        if (Array.isArray(components)) {
            components.forEach(function(arg) {
                addComponent(arg);
            });
        } else {
            if (components) {
                addComponent(components);
            }
        }
    }

    function hide(dismiss = false) {
        wrapperEl.classList.remove('show');
        events.dispatchEvent('hide', _public);
        if (dismiss) events.dispatchEvent('dismiss', _public);
        rTimeout = setTimeout(remove, props.removeTimeout);
    }

    function show() {
        if (rTimeout) {
            clearTimeout(rTimeout);
            rTimeout = null;
        }
        props.parent.append(wrapperEl);
        setTimeout(() => {
            wrapperEl.classList.add('show');
        }, 100);
        events.dispatchEvent('show', _public);
        wrapperEl.style.zIndex = ++zIncrement;

    }

    function dismissHandler(e) {
        e.preventDefault();
        if (props.dismissable) {
            hide(true);
        }
    }

    function clear() {
        modalEl.innerHTML = ''; // to do : remove properly the elements inside the modal to speed up the garbage collector
        events.dispatchEvent('clear', _public);
    }

    function remove() {
        events.dispatchEvent('remove', _public);
        wrapperEl.remove();
        rTimeout = null;
    }

    function addComponent(component) {
        modalEl.append(component.getElement ? component.getElement() : component);
    }

    constructor();

    let _public = {
        get props() {
            return props;
        },
        getElement: function() {
            return modalEl;
        },
        get element() {
            return element;
        },
        get wrapperElement() {
            return wrapperEl;
        },
        show: show,
        hide: hide,
        add: addComponent,
        clear: clear,
        remove: remove,
        on: events.addEventListener
    }

    andy.UI._instances.push(_public);
    return _public;
}

/***/ }),

/***/ "./js/ui/table/table.js":
/*!******************************!*\
  !*** ./js/ui/table/table.js ***!
  \******************************/
/*! exports provided: Table */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
function Table(p) {

    let events = new andy.EventManager();

    const props = {
        columns: {},
        rows: {},
        array: false,
        rowTemplate: defaultRowTemplate,
        dataset: null,
        className: 'andy-ui-table',
        placeholder: 'no_data_to_show',
        ...p
    }

    let rows = {};

    let element, head, body, placeholder;

    function constructor() {
        element = new TABLE(props.className);
        head = new THEAD('');
        body = new TBODY('');

        head.append(renderHeader());

        placeholder = new andy.UI.Label('no_data_to_show', { customClass: 'placeholder' });

        const placeholderCell = new TD('');
        placeholderCell.append(placeholder.element);
        placeholderCell.setAttribute('colspan', '100');
        body.append(placeholderCell);
        
        element.append(head, body);

        if (props.dataset) {
            bind(props.dataset);
        } else {
            setRows(props.rows);
        }

    }

    function renderHeader() {
        const tr = TR('');

        Object.keys(props.columns).forEach(key => {
            const column = props.columns[key];
            const th = new TH('');

            if (column.label) {
                const label = new andy.UI.Label(column.label);
                th.append(label.element);
            }

            if (column.style) {
                Object.assign(th.style, column.style);
            }

            if (column.className) {
                th.className = column.className;
            }

            tr.append(th);
        })

        return tr;
    }

    function renderRow(row) {
        const tr = new TR('');

        Object.keys(props.columns).forEach(key => {
            // const column = props.columns[key];

            const td = new TD('');
            const field = row[key];

            if (field) {
                td.append(field.element ? field.element : field);
            }

            tr.append(td);
        })

        return tr;
    }

    function setRows(items) {

        if (Array.isArray(items)) {
            props.array = true;
            items = {...items };
        }

        Object.keys(items).forEach(key => {
            set(key, items[key]);
        });
    }

    function set(key, value) {
        const row = {
            key,
            value,
            el: renderRow(props.rowTemplate(value, key)),
        }

        if (rows[key]) {
            rows[key].el.replaceWith(row.el);
            delete rows[key];
        } else {
            body.append(row.el);
        }

        rows[key] = row;
    }

    function remove(key) {
        const row = rows[key];
        if (row) {
            row.el.remove();
            delete row[key];
        }
    }

    function clear() {
        Object.values(rows).forEach(row => {
            row.el.remove();
        });
        rows = {};
    }

    function reset() {
        clear();
        setRows(props.rows);
    }

    function defaultRowTemplate(item) {
        return new DIV('andy-ui-list-item', item);
    }

    function bind(_dataset) {

        const _key = _dataset.props.key;

        clear();

        if (Object.values(_dataset.data).length > 0) {
            setRows(_dataset.data);
        }

        _dataset.on('fetch', function({ dataset }) {
            clear();
            setRows(dataset);
        });

        _dataset.on('remove', function({ document }) {
            remove(document[_key]);
        });


        _dataset.on('save', function({ document }) {
            set(document[_key], document);
        });

    }

    function search() {

    }

    function getValue() {
        const output = {};

        Object.values(rows).forEach(row => {
            output[row.key] = row.value;
        });

        if (props.array) {
            return Object.values({...output });
        }
        return {...output };
    }

    constructor();

    let _public = {
        get props() {
            return props;
        },
        getElement: function() {
            return element;
        },
        get element() {
            return element;
        },
        get value() {
            return getValue();
        },
        set,
        add: set,
        setValue: setRows,
        clear,
        reset,
        remove,
        bind,
        search,
        getValue,
        on: events.on
    }

    andy.UI._instances.push(_public);
    return _public;
}

/***/ })

/******/ });
//# sourceMappingURL=main.js.map